<template>
  <!-- ---------------------------------- AIR ---------------------------------- -->
  <div class="air">
    <div id="mask" v-show="mask" @click="showCont"></div>
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Header></Header>
    <!-- ---------------------------------- 标签栏 ---------------------------------- -->
    <div class="air_tab">
      <span
        :class="{ 'tab-span-tit': true, select_tab: tabId === index }"
        v-for="(item, index) in tabList"
        :key="index"
        @click="
          tabId = index;
          play = true;
          formData1.provinceValue = undefined;
          formData1.cityValue = undefined;
          formData1.nameValue = '';
          formData1.phoneValue = '';
          formData1.code = undefined;
          formData1.codeOne = undefined;
          formData1.codeTwo = undefined;
        "
        >{{ item.title }}<br />{{ item.main }}</span
      >
    </div>
    <!-- ---------------------------------- RA 488 ---------------------------------- -->
    <div v-show="tabId == 0" class="tabs_one">
      <div v-if="imgList1.length > 1" class="banner">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in imgList1" :key="index">
            <div v-if="index === 0" class="banner_box">
              <div
                class="banner_main"
                style="
                  position: absolute;
                  top: 0;
                  align-items: center;
                  height: 100%;
                "
              >
                <!-- 产品图 -->
                <!-- <img class="banner_pro1" @click="tiaoZhuan1(index)" src="../assets/images/488-1.png" alt="" style="margin-bottom: 15%;"/> -->
                <img
                  class="banner_pro2222"
                  @click="tiaoZhuan1(index)"
                  src="../assets/images/RA488-3.png"
                  alt=""
                  style="margin-bottom: 15%"
                />

                <div class="propk" v-if="item.video">
                  <div
                    style="
                      position: absolute;
                      top: -500%;
                      z-index: 11;
                      left: -1400%;
                    "
                  >
                    <video
                      :src="
                        'http://118.89.87.102:8080/jeecg-boot/sys/common/static/video/' +
                        item.video
                      "
                      v-show="show2"
                      @click="showCont"
                    ></video>
                  </div>
                  <img
                    @click="showCont"
                    src="../assets/images/bofang.png"
                    slot="reference"
                    class="bfbtn"
                  />
                </div>
                <!-- 文案 -->
                <div
                  class="banner_copy1"
                  style="width: 100%; height: 100%; position: relative"
                >
                  <!-- 横线 -->
                  <!-- <img class="banner_line1" src="../assets/images/graphic-line1.png" alt="" /> -->
                  <p
                    style="
                      color: rgb(18 28 81);
                      position: absolute;
                      top: 35%;
                      left: 48%;
                    "
                  >
                    一个20平方米的空间，<br />空气净化一次，仅需9分钟！
                  </p>
                  <!-- LOGO -->
                  <!-- <img class="banner_logo" src="../assets/images/icon/air-logo-white.png" alt="" /> -->
                </div>
              </div>
            </div>

            <div v-if="index === 1" class="banner_box">
              <div class="banner_main"  style="
                  position: absolute;
                  top: 0;
                  align-items: center;
                  height: 100%;
                ">
                  <img
                  class="banner_pro2222"
                  src="../assets/images/air-banner.png"
                  alt=""
              
                />
                <!-- 文案 -->
                <div class="banner_copy1">
                  <!-- 横线 -->
                  <img
                    class="banner_line2"
                    src="../assets/images/graphic-line2.png"
                    alt=""
                  />
                  <p>轻松透过手机APP<br />远程监察及控制<br />空气素质</p>
                  <!-- LOGO -->
                  <img
                    class="banner_logo"
                    src="../assets/images/icon/air-logo-white.png"
                    alt=""
                  />
                </div>
                <!-- 产品图 -->
                <img
                  class="banner_pro2"
                  @click="tiaoZhuan1(index)"
                  src="../assets/images/air-lb2.png"
                  alt=""
                />
                <div class="propk" v-if="item.video">
                  <div
                    style="
                      position: absolute;
                      top: -500%;
                      z-index: 11;
                      left: -1400%;
                    "
                  >
                    <video
                      :src="
                        'http://118.89.87.102:8080/jeecg-boot/sys/common/static/video/' +
                        item.video
                      "
                      v-show="show2"
                      @click="showCont"
                    ></video>
                  </div>
                  <img
                    @click="showCont"
                    src="../assets/images/bofang.png"
                    slot="reference"
                    class="bfbtn"
                  />
                </div>
              </div>
            </div>
            <div v-if="index === 2" class="banner_box">
              <div class="banner_main"  style="
                  position: absolute;
                  top: 0;
                  align-items: center;
                  height: 100%;
                ">
                  <img
                  class="banner_pro2222"
                  src="../assets/images/air-banner.png"
                  alt=""
              
                />
                <!-- 产品图 -->
                <img
                  class="banner_pro3"
                  @click="tiaoZhuan1(index)"
                  src="../assets/images/air-lb3.png"
                  alt=""
                  style="margin-top: 14%"
                />
                <div class="propk" v-if="item.video">
                  <div
                    style="
                      position: absolute;
                      top: -500%;
                      z-index: 11;
                      left: -1400%;
                    "
                  >
                    <video
                      :src="
                        'http://118.89.87.102:8080/jeecg-boot/sys/common/static/video/' +
                        item.video
                      "
                      v-show="show2"
                      @click="showCont"
                    ></video>
                  </div>
                  <img
                    @click="showCont"
                    src="../assets/images/bofang.png"
                    slot="reference"
                    class="bfbtn"
                  />
                </div>
                <!--                <img class="banner_pro1" @click="tiaoZhuan1(index)" v-lazy="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
                <!-- 文案 -->
                <div class="banner_copy1" style="margin-top: 12%">
                  <!-- 横线 -->
                  <img
                    class="banner_line3"
                    src="../assets/images/graphic-line2.png"
                    alt=""
                  />
                  <p style="margin: 5% 0">
                    PM2.5显示实时监测<br />您家或办公室的<br />空气质量
                  </p>
                  <!-- LOGO -->
                  <img
                    class="banner_logo"
                    src="../assets/images/icon/air-logo-white.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div
            class="swiper-button-prev swiper-button-prev-new"
            slot="button-prev"
          >
            <i class="el-icon-arrow-left"></i>
          </div>
          <div
            class="swiper-button-next swiper-button-next-new"
            slot="button-next"
          >
            <i class="el-icon-arrow-right"></i>
          </div>
        </swiper>
        <!--如果你需要分页-->
        <div class="swiper-pagination" slot="pagination"></div>
        <!--如果需要前进后退按钮-->
        <div class="swiper-button-next2"></div>
        <div class="swiper-button-prev2"></div>
      </div>
      <div v-if="imgList1.length <= 1">
        <div v-for="(item, index) in imgList1" :key="index">
          <img
            class="banner"
            @click="tiaoZhuan1(index)"
            v-lazy="
              'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
              item.imgUrl
            "
            alt=""
          />
          <p
            style="
              margin: 5% 0;
              position: absolute;
              top: 25%;
              color: #fff;
              font-size: 30px;
              left: 50%;
            "
            v-html="item.remarks"
          ></p>
        </div>
      </div>
      <div v-if="play">
        <!-- 导航栏 -->
        <div class="Air-two-mulu">
          <div class="two-label">
            <el-tabs v-model="activeName">
              <el-tab-pane label="全部" name="all"></el-tab-pane>
              <el-tab-pane label="有关产品" name="1"></el-tab-pane>
              <el-tab-pane label="过滤净化功能" name="2"></el-tab-pane>
              <el-tab-pane label="产品特点" name="3"></el-tab-pane>
              <el-tab-pane label="服务介绍" name="4"></el-tab-pane>
              <el-tab-pane label="规格" name="5"></el-tab-pane>
              <el-tab-pane label="检测" name="6"></el-tab-pane>
              <el-tab-pane label="过滤配件" name="7"></el-tab-pane>
              <el-tab-pane label="其他" name="8"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="two-anniu">
            <div class="two-anniu-anniu" @click="form()">咨询</div>
          </div>
        </div>
        <!-- 有关产品 -->
        <div
          id="aaa"
          class="Air-san-mlyi"
          v-if="activeName === 'all' || activeName === '1'"
        >
          <div class="mlyi-tit">有关产品</div>
          <div class="mlyi-list">
            <div class="yycp">
              <img
                src="../assets/images/icon/air-m.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">适用面积：34－58m²</span>
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-ccm.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">颗粒物：P4<br />甲醛：F4</span>
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-cadr.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title"
                >颗粒物：488m³/h <br />甲醛：100m³/h</span
              >
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-yz.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">高能效等级</span>
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-f.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">五层过滤 七重净化</span>
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-sy.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">低噪音</span>
            </div>
          </div>
        </div>
        <!-- 七重过滤 -->
        <div
          class="Air-qi-guolv"
          v-if="activeName === 'all' || activeName === '2'"
        >
          <div class="guolv-tit auto-size-30">五层过滤 七重净化</div>
          <div class="num_box">
            <img
              src="../assets/images/air-gl.png"
              alt=""
              style="margin: 0 auto; display: flex"
            />
            <!-- 数字按钮 -->
            <div
              @click="showNum2()"
              class="check_button number1 anniu-2"
              :class="showId === 2 ? 'select_button' : ''"
            >
              2
            </div>
            <div
              @click="showNum4()"
              class="check_button anniu-4"
              :class="showId === 4 ? 'select_button' : ''"
              id="anniu-4"
            >
              4
            </div>
            <div
              @click="showNum6()"
              class="check_button anniu-6"
              :class="showId === 6 ? 'select_button' : ''"
              id="anniu-6"
            >
              6
            </div>
            <div
              @click="showNum1()"
              class="check_button anniu-1"
              :class="showId === 1 ? 'select_button' : ''"
            >
              1
            </div>
            <div
              @click="showNum3()"
              class="check_button anniu-3"
              id="anniu-3"
              :class="showId === 3 ? 'select_button' : ''"
            >
              3
            </div>
            <div
              @click="showNum5()"
              class="check_button anniu-5"
              :class="showId === 5 ? 'select_button' : ''"
              id="anniu-5"
            >
              5
            </div>
            <div
              @click="showNum7()"
              class="check_button anniu-7"
              :class="showId === 7 ? 'select_button' : ''"
            ></div>
            <div
              @click="showNum7()"
              class="check_button anniu-7"
              :class="showId === 7 ? 'select_button' : ''"
            >
              7
            </div>
          </div>
          <div class="guolv-desc" v-if="showId === 1">
            <p style="font-weight: bold">1 | 初效滤网</p>
            <p style="line-height: 2">
              能过滤5微米以上尘埃粒子，包括大颗粒粉尘、毛屑、花粉、漂浮物等污染物。可多次清洗，重复利用。
            </p>
          </div>
          <div class="guolv-desc" v-if="showId === 2">
            <p style="font-weight: bold">2 | 冷触媒滤网</p>
            <p style="line-height: 2">
              能同时催化甲醛、氨气、苯类、TVOC、硫化氢等多种有害气体与空气中的氧气发生反应，进行催化，生成水和二氧化碳。
            </p>
          </div>
          <div class="guolv-desc" v-if="showId === 3">
            <p style="font-weight: bold">3 | 蜂窝活性炭</p>
            <p style="line-height: 2">
              能去除各种有害气体，分解吸附甲醛，甲苯、二甲苯、氨等有害物，去除率达到99%以上，其速度快，饱和吸附量大。
            </p>
          </div>
          <div class="guolv-desc" v-if="showId === 4">
            <p style="font-weight: bold">4 | 抗菌棉滤网</p>
            <p style="line-height: 2">
              能破坏细菌的细胞壁，使细胞膜破裂，胞浆外泄，从而终止了微生物的代谢过程，使微生物无法生长和繁殖,对螨虫和细菌等具有去除作用。
            </p>
          </div>
          <div class="guolv-desc" v-if="showId === 5">
            <p style="font-weight: bold">5 | H13级HEPA滤网</p>
            <p style="line-height: 2">
              HEPA过滤网是一种新型高放空气净化材料，在常温下不需要任何能源，就可以达到除尘
              (99.97％)、杀菌 (99.97％)
              的目的。对于0.3微米或以上的粉尘（烟雾、花粉、灰尘等）吸附率可达99.97％，对枯草菌具有高效杀灭能力，对一般细菌也有很强的抑制作用。
            </p>
          </div>
          <div class="guolv-desc" v-if="showId === 6">
            <p style="font-weight: bold">6 | UV紫外线灯</p>
            <p style="line-height: 2">
              采用365纳米波长紫外线的光源，可杀灭空气中的多种细菌。紫外线杀菌灯一般用来对空气、物体表面和水进行消毒杀菌；它能净化空气、消除霉味，此外还能产生一定量的负离子，经紫外线消毒过的房间，空气特别清新，同时可减少一些病毒经空气、物体表面传播。
            </p>
          </div>
          <div class="guolv-desc" v-if="showId === 7">
            <p style="font-weight: bold">7 | 负离子发生器</p>
            <p style="line-height: 2">
              负离子能使通常带正电荷的室内尘埃、烟雾、细菌相互聚集，使其失去在空气中自由漂浮的能力并迅速降落，从而净化空气。负离子释放对人体健康有益的小粒径负离子。负离子不仅能除尘、净化空气,还能促成人体合成和储存维生素，强化和激活人体的生理活动，因此它被称为「空气维生素」。1000万/cm³的高浓度负离子让您的身体补充充足的「维生素」。
            </p>
          </div>
        </div>
        <!-- 产品特点 -->
        <div
          class="Air-wu-protd"
          v-if="activeName === 'all' || activeName === '3'"
        >
          <div class="prottedian-tit">产品特点</div>
          <div class="prottedian-list">
            <AirProTDTransverse :list="protdList"></AirProTDTransverse>
          </div>
        </div>
        <!-- 服务介绍 -->
        <div
          class="Air-liu-jieshao"
          v-if="activeName === 'all' || activeName === '4'"
        >
          <div class="fw-jieshao">优质空气服务介绍</div>
          <div class="jieshao-desc">
            Renaud品牌通过免费提供的高效空气净化设备及每6个月一次的免费上门服务，以确保客户的室内空气处于安全的水平，同时亦保证设备一直处于最佳的使用状态。服务内容如下：
          </div>
          <div class="jieshao-list">
            <div class="js-diyi" v-for="(item, index) in jsList" :key="index">
              <img v-lazy="item.url" alt="" />
              <span class="js-titbiaoti">{{ item.jsTit }}</span>
            </div>
          </div>
          <div class="js-diyi-zuihiu">
            <img src="../assets/images/icon/air-js7.png" alt="" />
            <span class="js-titbiaoti-zuihiu"
              >每6个月免费上门ー次维护及保养设备，包括：</span
            >
          </div>
          <ul class="titbiaoti-zuihiu-ul">
            <li
              class="zuihou-ul0li-tit"
              v-for="(item, index) in fwjsList"
              :key="index"
              v-html="item.title"
            ></li>

            <!-- <li
                            class="zuihou-ul0li-tit"
                            v-for="(item, index) in fwjsList"
                            :key="index"
                        >
                            <span v-html="item.title"></span>
                        </li> -->
          </ul>
        </div>
        <!-- 规格 -->
        <div
          class="air-qi-guige"
          v-if="activeName === 'all' || activeName === '5'"
        >
          <div class="guige-titbiaoti">规格</div>
          <div class="guige-nr">
            <div class="guige-nr-left">
              <div
                class="cp-mc"
                v-for="(item, index) in guigeLeftList"
                :key="index"
              >
                <span class="cp-mc-biaoti cp-mc-biaoti_left"
                  >{{ item.getit }}
                </span>
                <span class="cp-mc-shuoming" v-html="item.gename"> </span>
              </div>
            </div>
            <div class="guige-nr-rig">
              <div
                class="cp-mc"
                v-for="(item, index) in guigeRigList"
                :key="index"
              >
                <span class="cp-mc-biaoti"> {{ item.getit }}</span>
                <span class="cp-mc-shuoming">{{ item.gename }} </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 检测 -->
        <div
          class="air-ba-jiance"
          v-if="activeName === 'all' || activeName === '6'"
        >
          <div class="jiance-titbiaoti">检测</div>
          <div class="jc-desc" id="jc-wn" style="margin-left: -4px">
            <p>蔚诺488系列空气净化器符合GB/T</p>
            <p>18801-2015空气净化器新国标</p>
          </div>
          <img
            class="add_pic"
            src="../assets/images/icon/air-jiahao.png"
            alt=""
          />
          <div class="jc-pic">
            <!-- <div>
              <div class="jc-desc">
                <p>H1N1及EV71</p>
                <p>检测报告</p>
              </div> -->
            <!-- 图一 -->
            <div class="jctupian">
              <img
                @click="showPic1 = true"
                src="../assets/images/RA488-detection1.png"
                alt=""
                style="width: 160px; height: 240px"
              />
            </div>
            <!-- </div> -->

            <el-dialog title="" class="dialog" :visible.sync="showPic1" center>
              <img
                src="../assets/images/RA488-detection1.png"
                alt=""
                style="width: 95%"
              />
            </el-dialog>
            <!-- 图二 -->
            <!-- <div>
              <div class="jc-desc">
                <p>多种有害气体及细菌</p>
                <p>检测报告(A)</p>
              </div> -->
            <div class="jctupian">
              <img
                @click="showPic2 = true"
                src="../assets/images/RA488-detection2.png"
                alt=""
                style="width: 160px; height: 240px"
              />
            </div>
            <!--  </div> -->
            <el-dialog title="" class="dialog" :visible.sync="showPic2" center>
              <img
                src="../assets/images/RA488-detection2.png"
                alt=""
                style="width: 95%"
              />
            </el-dialog>

            <!-- <div>
              <div class="jc-desc">
                <p>多种有害气体及细菌</p>
                <p>检测报告(B)</p>
              </div> -->
            <!-- 图三 -->
            <div class="jctupian">
              <img
                @click="showPic3 = true"
                src="../assets/images/RA488-detection3.png"
                alt=""
                style="width: 160px; height: 240px"
              />
            </div>
            <!-- </div> -->
            <el-dialog title="" class="dialog" :visible.sync="showPic3" center>
              <img
                src="../assets/images/RA488-detection3.png"
                alt=""
                style="width: 95%"
              />
            </el-dialog>
          </div>
        </div>
        <!-- 过滤配件 -->
        <div
          class="Air-jiu-guolvpj"
          v-if="activeName === 'all' || activeName === '7'"
        >
          <div class="guolvpj-titbiaoti">过滤配件</div>
          <!-- 复合滤网 -->
          <div class="guolvpj-nr">
            <div class="peijian-left">
              <div class="glpj-pic-bj">
                <img
                  src="../assets/images/ra488-pic2.png"
                  alt=""
                  style="width: 100%"
                />
              </div>
              <div class="glpj-anniu">
                <div class="pj-anniu-zixun" @click="form2()">咨询</div>
                <!-- <div style="margin-top:3%;color:#595757;">Medic Filter</div> -->
              </div>
            </div>
            <div class="peijian-rig">
              <div class="pj-duanluo">
                <div class="pj-smaltit">RA488 H13高效HEPA复合滤网</div>
              </div>
              <div class="pj-duanluo">
                <div class="pj-smaltit" style="font-weight: normal">
                  技术规格
                </div>
                <!-- 横线 -->
                <div class="pj-line"></div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">型号：</span>
                  <span class="cp-mc-shuoming"> RA488-HC</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">滤网数量：</span>
                  <span class="cp-mc-shuoming"
                    >1片（2号冷触媒滤网、3号活性炭滤网）<br />1片（4号抗菌棉滤网、5号HEPA高效滤网）</span
                  >
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">HEPA级别：</span>
                  <span class="cp-mc-shuoming"
                    >H13级别（有效过滤99.97% @ 0.3微米颗粒物）</span
                  >
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">建议使用时间：</span>
                  <span class="cp-mc-shuoming">6个月</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">尺寸：</span>
                  <span class="cp-mc-shuoming">45x35x3.5厘米（每一片）</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 加湿滤网 -->
          <div class="guolvpj-nr">
            <div class="peijian-left">
              <div class="glpj-pic-bj">
                <img
                  src="../assets/images/ra488-pic.png"
                  alt=""
                  style="width: 100%"
                />
              </div>
              <div class="glpj-anniu">
                <div class="pj-anniu-zixun" @click="form3()">咨询</div>
                <!-- <div style="margin-top:3%;color:#595757;">Medic Filter</div> -->
              </div>
            </div>
            <div class="peijian-rig">
              <div class="pj-duanluo">
                <div class="pj-smaltit">RA488加湿滤网</div>
              </div>
              <div class="pj-duanluo">
                <div class="pj-smaltit" style="font-weight: normal">
                  技术规格
                </div>
                <!-- 横线 -->
                <div class="pj-line"></div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">型号：</span>
                  <span class="cp-mc-shuoming"> RA488-HUM</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">过滤器数量：</span>
                  <span class="cp-mc-shuoming"> 1片</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">建议使用时间：</span>
                  <span class="cp-mc-shuoming">6个月</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">尺寸：</span>
                  <span class="cp-mc-shuoming">27.5x13x2厘米</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 其他 -->
        <div
          class="Air-shi-qita"
          v-if="activeName === 'all' || activeName === '8'"
        >
          <div class="qita-titbiaoti">其他</div>
          <div class="">
            <AirQiTaTransverse :list="qiTaList"></AirQiTaTransverse>
          </div>
        </div>
      </div>
      <!-- 表单 -->
      <div class="air_form" v-if="play == false">
        <!-- 返回按钮 -->
        <div class="form_back" @click="form_back()">返回</div>
        <!-- 标题 -->
        <p class="form_title" v-if="playid == 0">
          咨询：<span>RA488 高效空气净化器</span>
        </p>
        <p class="form_title" v-if="playid == 1">
          咨询：<span>RA488 H13高效HEPA复合滤网</span>
        </p>
        <p class="form_title" v-if="playid == 2">
          咨询：<span>RA488 加湿滤网</span>
        </p>
        <!-- 表单 -->
        <div class="form_main">
          <!-- 请选择省份 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-paper.png" alt="" />
            </div>

            <el-select
              v-model="formData1.provinceValue"
              @change="getCity"
              placeholder="请选择省份"
              class="form_input"
              placeholder-style="color:#585858"
              style="margin-left: 0.02rem"
            >
              <el-option
                v-for="(item, index) in provinceArr"
                :key="index"
                :label="item.provinceCn"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 请选择城市 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-tag.png" alt="" />
            </div>
            <el-select
              v-model="formData1.cityValue"
              placeholder="请选择城市"
              class="form_input"
              no-data-text="无数据"
              style="margin-left: 0.02rem"
            >
              <el-option
                v-for="(item, index) in cityArr"
                :key="index"
                :label="item.cityCn"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 请输入姓名 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-man.png" alt="" />
            </div>
            <el-input
              type="text"
              placeholder="请输入姓名"
              v-model="formData1.nameValue"
              class="form_input"
            />
          </div>
          <!-- 请输入手机号 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-phone.png" alt="" />
            </div>
            <el-input
              type="text"
              placeholder="请输入手机号"
              v-model="formData1.phoneValue"
              class="form_input"
              @blur="phoneRule"
            />
          </div>
          <!-- 邀请码 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-message.png" alt="" />
            </div>
            <el-select
              v-model="formData1.code"
              @change="qingKong"
              placeholder="邀请码"
              style="margin-left: 0.03rem"
            >
              <el-option :value="1" label="没有">没有</el-option>
              <el-option :value="2" label="有">有</el-option>
            </el-select>
            <el-select
              v-if="formData1.code === 1"
              v-model="formData1.codeTwo"
              placeholder="选择"
            >
              <el-option :value="1" label="确定没有">确定没有</el-option>
              <el-option :value="2" label="不清楚">不清楚</el-option>
            </el-select>
            <el-input
              v-if="formData1.code === 2"
              v-model="formData1.codeTwo"
              :value="0"
              placeholder="请输入邀请码"
              class="margin1"
            >
            </el-input>
          </div>
          <!-- 提交按钮 -->
          <div class="form_button">
            <div class="button_title" @click="commit1()">提交</div>
            <div class="button_icon" @click="commit1()">
              <img src="../assets/images/icon/play-white.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ---------------------------------- RA 800 ---------------------------------- -->
    <div v-show="tabId == 1" class="tabs_one">
      <!-- 海报图 -->
      <!--      <div class="banner">-->
      <!--        <a-carousel arrows dots=false>-->
      <!--          <div-->
      <!--            slot="prevArrow"-->
      <!--            class="custom-slick-arrow"-->
      <!--            style="left: 10px;zIndex: 1"-->
      <!--          >-->
      <!--            <a-icon type="left-circle" />-->
      <!--          </div>-->
      <!--          <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">-->
      <!--            <a-icon type="right-circle" />-->
      <!--          </div>-->
      <!--          <div class="banner_box">-->
      <!--            &lt;!&ndash; 背景图 &ndash;&gt;-->
      <!--            <img class="banner_bgimg" src="../assets/images/air-banner.png" alt="">-->
      <!--            &lt;!&ndash; 内容 &ndash;&gt;-->
      <!--            <div class="banner_main" style="position: absolute;top:17%;left:0;align-items: center;">-->
      <!--              &lt;!&ndash; 文案 &ndash;&gt;-->
      <!--              <div class="banner_copy1">-->
      <!--                &lt;!&ndash; 横线 &ndash;&gt;-->
      <!--                <img class="banner_line1" src="../assets/images/graphic-line1.png" alt="">-->
      <!--                <p>一个30平方米的空间，<br>空气净化一次，仅需6分钟！</p>-->
      <!--                &lt;!&ndash; LOGO &ndash;&gt;-->
      <!--                <img class="banner_logo" src="../assets/images/icon/air-logo-white.png" style="margin-top:50px;" alt="">-->
      <!--              </div>-->
      <!--              &lt;!&ndash; 产品图 &ndash;&gt;-->
      <!--              <img class="banner_pro1" style="margin-left:3%;" src="../assets/images/RA800.png" alt="">-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="banner_box">-->
      <!--            &lt;!&ndash; 内容 &ndash;&gt;-->
      <!--            <div class="banner_main" style="position: absolute;bottom:0;">-->
      <!--              &lt;!&ndash; 产品图 &ndash;&gt;-->
      <!--              <img class="banner_pro3" src="../assets/images/RA8003.png" alt="">-->
      <!--              &lt;!&ndash; 文案 &ndash;&gt;-->
      <!--              <div class="banner_copy1">-->
      <!--                &lt;!&ndash; 横线 &ndash;&gt;-->
      <!--                <img class="banner_line3" src="../assets/images/graphic-line2.png" alt="">-->
      <!--                <p style="margin:5% 0;">轻松透过手机APP<br>远程监察及控制<br>空气质素</p>-->
      <!--                &lt;!&ndash; LOGO &ndash;&gt;-->
      <!--                <img class="banner_logo" src="../assets/images/icon/air-logo-white.png" alt="">-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="banner_box">-->
      <!--            &lt;!&ndash; 内容 &ndash;&gt;-->
      <!--            <div class="banner_main" style="position: absolute;bottom:0;">-->
      <!--              &lt;!&ndash; 产品图 &ndash;&gt;-->
      <!--              <img class="banner_pro4" src="../assets/images/RA8002.png" alt="">-->
      <!--              &lt;!&ndash; 文案 &ndash;&gt;-->
      <!--              <div class="banner_copy1">-->
      <!--                &lt;!&ndash; 横线 &ndash;&gt;-->
      <!--                <img class="banner_line3" src="../assets/images/graphic-line2.png" alt="" style="padding-top:15%;">-->
      <!--                <p style="margin:5% 0;">PM2.5显示实时监测<br>您家或办公室的<br>空气质量</p>-->
      <!--                &lt;!&ndash; LOGO &ndash;&gt;-->
      <!--                <img class="banner_logo" src="../assets/images/icon/air-logo-white.png" alt="">-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </a-carousel>-->
      <!--      </div>-->
      <div v-if="imgList2.length > 1" class="banner">
        <a-carousel arrows :dots="false">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in imgList2" :key="index">
              <!--            <img class="banner" @click="tiaoZhuan2(index)" v-lazy="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
              <!--            <p style="margin:5% 0;position:absolute;top: 25%; color: #fff;font-size:30px;left: 20%" v-if="index == 0" v-html="item.remarks"></p>-->
              <!--            <p style="margin:5% 0;position:absolute;top: 25%; color: #fff;font-size:30px;left: 55%" v-else-if="index == 1" v-html="item.remarks"></p>-->
              <!--            <p style="margin:5% 0;position:absolute;top: 25%; color: #fff;font-size:30px;left: 55%" v-else="index == 2" v-html="item.remarks"></p>-->
              <div v-if="index === 0" class="banner_box">
                <!-- 背景图 -->
                <img
                  class="banner_bgimg banner-bkg"
                  style="z-index: -1000"
                  src="../assets/images/air-banner.png"
                  alt=""
                />
                <!-- 内容 -->
                <div
                  class="banner_main"
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    align-items: center;
                    height: 100%;
                  "
                  id="banner-ra800"
                >
               
                  <!-- 文案 -->

                  <div
                    class="banner_copy1"
                    style="
                      z-index: 1000;
                      width: 100%;
                      height: 100%;
                      position: relative;
                    "
                  >
                    <!-- 横线 -->
                    <!-- <img class="banner_line11" src="../assets/images/graphic-line1.png" alt="" /> -->
                    <p
                      class="rtxt-ma960"
                      style="
                        color: rgb(17 38 83);
                        position: absolute;
                        left: 18%;
                        top: 45%;
                      "
                    >
                      一个30平方米的空间，<br />空气净化一次，<br />仅需6分钟！
                    </p>
                    <p
                      class="rtxt-mi960"
                      style="
                        color: rgb(17 38 83);
                        position: absolute;
                        left: 18%;
                        top: 45%;
                      "
                    >
                      一个30平方米的空间，<br />空气净化一次，仅需6分钟！
                    </p>
                    <!-- LOGO -->
                    <!-- <img class="banner_logo" src="../assets/images/icon/air-logo-white.png" style="margin-top: 50px" alt="" /> -->
                  </div>
                  <!-- <p  style="color:rgb(17 38 83);
                        letter-spacing: 0.03125rem;
                        margin-bottom: 5%;
                        line-height: 1.5;
                        text-align: left;
                        font-size: 0.302083rem;
                        z-index:1000;
                        position:relative;
                        left:-11%;
                        padding-top:13%;
                        font-weight:500"
                        >
                        一个30平方米的空间，<br />空气净化一次，仅需6分钟！</p> -->

                  <!-- 产品图 -->
                  <!-- <img class="banner_pro1" @click="tiaoZhuan2(index)" style="margin-left: 3%"
                    src="../assets/images/RA800.png" alt="" /> -->
                  <img
                    class="banner_pro3333"
                    @click="tiaoZhuan2(index)"
                    src="../assets/images/RA800-3.png"
                    alt=""
                    style="z-index: 500"
                  />
                  <div class="propk" v-if="item.video">
                    <div
                      style="
                        position: absolute;
                        top: -500%;
                        z-index: 11;
                        left: -1400%;
                      "
                    >
                      <video
                        :src="
                          'http://118.89.87.102:8080/jeecg-boot/sys/common/static/video/' +
                          item.video
                        "
                        v-show="show2"
                        @click="showCont"
                      ></video>
                    </div>
                    <img
                      @click="showCont"
                      src="../assets/images/bofang.png"
                      slot="reference"
                      class="bfbtn"
                    />
                  </div>
                </div>
              </div>

              <div class="banner_box" v-if="index === 1">
                <!-- 内容 -->
                <div class="banner_main"  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    align-items: center;
                    height: 100%;
                  ">
                    <img
                  class="banner_pro2222"
                  src="../assets/images/air-banner.png"
                  alt=""
              
                />
                  <!-- 产品图 -->
                  <img
                    class="banner_pro3"
                    @click="tiaoZhuan2(index)"
                    src="../assets/images/RA8003.png"
                    alt=""
                  />
                  <div class="propk" v-if="item.video">
                    <div
                      style="
                        position: absolute;
                        top: -500%;
                        z-index: 11;
                        left: -1400%;
                      "
                    >
                      <video
                        :src="
                          'http://118.89.87.102:8080/jeecg-boot/sys/common/static/video/' +
                          item.video
                        "
                        v-show="show2"
                        @click="showCont"
                      ></video>
                    </div>
                    <img
                      @click="showCont"
                      src="../assets/images/bofang.png"
                      slot="reference"
                      class="bfbtn"
                    />
                  </div>
                  <!-- 文案 -->
                  <div class="banner_copy1">
                    <!-- 横线 -->
                    <img
                      class="banner_line13"
                      src="../assets/images/graphic-line2.png"
                      alt=""
                    />
                    <p style="margin: 5% 0">
                      轻松透过手机APP<br />远程监察及控制<br />空气素质
                    </p>
                    <!-- LOGO -->
                    <img
                      class="banner_logo"
                      src="../assets/images/icon/air-logo-white.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div class="banner_box" v-if="index === 2">
                <!-- 内容 -->
                <div class="banner_main" style=" position: absolute;
                    top: 0;
                    left: 0;
                    align-items: center;
                    height: 100%;">
                   <img
                  class="banner_pro2222"
                  src="../assets/images/air-banner.png"
                  alt=""
              
                />
                  <!-- 产品图 -->
                  <img
                    class="banner_pro4"
                    @click="tiaoZhuan2(index)"
                    src="../assets/images/RA8002.png"
                    alt=""
                  />
                  <div class="propk" v-if="item.video">
                    <div
                      style="
                        position: absolute;
                        top: -500%;
                        z-index: 11;
                        left: -1400%;
                      "
                    >
                      <video
                        :src="
                          'http://118.89.87.102:8080/jeecg-boot/sys/common/static/video/' +
                          item.video
                        "
                        v-show="show2"
                        @click="showCont"
                      ></video>
                    </div>
                    <img
                      @click="showCont"
                      src="../assets/images/bofang.png"
                      slot="reference"
                      class="bfbtn"
                    />
                  </div>
                  <!-- 文案 -->
                  <div class="banner_copy1">
                    <!-- 横线 -->
                    <img
                      class="banner_line3"
                      src="../assets/images/graphic-line2.png"
                      alt=""
                      style="padding-top: 15%"
                    />
                    <p style="margin: 5% 0">
                      PM2.5显示实时监测<br />您家或办公室的<br />空气质量
                    </p>
                    <!-- LOGO -->
                    <img
                      class="banner_logo"
                      src="../assets/images/icon/air-logo-white.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div
              class="swiper-button-prev swiper-button-prev-new"
              slot="button-prev"
            >
              <i class="el-icon-arrow-left"></i>
            </div>
            <div
              class="swiper-button-next swiper-button-next-new"
              slot="button-next"
            >
              <i class="el-icon-arrow-right"></i>
            </div>
          </swiper>
          <!--如果你需要分页-->
          <div class="swiper-pagination" slot="pagination"></div>
          <!--如果需要前进后退按钮-->
          <div class="swiper-button-next2"></div>
          <div class="swiper-button-prev2"></div>
        </a-carousel>
      </div>
      <div v-if="imgList2.length <= 1">
        <div v-for="(item, index) in imgList2" :key="index">
          <!--            <img class="banner" v-lazy="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
          <img
            class="banner"
            @click="tiaoZhuan2(index)"
            v-lazy="
              'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
              item.imgUrl
            "
            alt=""
          />
          <p
            style="
              margin: 5% 0;
              position: absolute;
              top: 25%;
              color: #fff;
              font-size: 30px;
              left: 20%;
            "
            v-html="item.remarks"
          ></p>
        </div>
      </div>
      <div v-if="play">
        <!-- 导航栏 -->
        <div class="Air-two-mulu">
          <div class="two-label">
            <el-tabs v-model="activeName">
              <el-tab-pane label="全部" name="all"></el-tab-pane>
              <el-tab-pane label="有关产品" name="1"></el-tab-pane>
              <el-tab-pane label="过滤净化功能" name="2"></el-tab-pane>
              <el-tab-pane label="产品特点" name="3"></el-tab-pane>
              <el-tab-pane label="服务介绍" name="4"></el-tab-pane>
              <el-tab-pane label="规格" name="5"></el-tab-pane>
              <el-tab-pane label="检测" name="6"></el-tab-pane>
              <el-tab-pane label="过滤配件" name="7"></el-tab-pane>
              <el-tab-pane label="其他" name="8"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="two-anniu">
            <div class="two-anniu-anniu" @click="form()">咨询</div>
            <!-- <div class="two-anniu-anniu" @click="goumaiTZ()">购买</div> -->
          </div>
        </div>
        <!-- 有关产品 -->
        <div
          class="Air-san-mlyi"
          v-if="activeName === 'all' || activeName === '1'"
        >
          <div class="mlyi-tit">有关产品</div>
          <div class="mlyi-list">
            <div class="yycp">
              <img
                src="../assets/images/icon/air-m.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">适用面积：56－96m²</span>
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-ccm.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">颗粒物：P4<br />甲醛：F4</span>
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-cadr.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title"
                >颗粒物：800m³/h <br />甲醛：400m³/h</span
              >
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-yz.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">高能效等级</span>
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-f.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">多重全面净化</span>
            </div>
            <div class="yycp">
              <img
                src="../assets/images/icon/air-sy.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">低噪音</span>
            </div>
          </div>
        </div>
        <!-- 多重全面净化 -->
        <div
          class="Air-qi-guolv"
          v-if="activeName === 'all' || activeName === '2'"
        >
          <div class="guolv-tit_muti1 guolv-tit">多重全面净化</div>
          <div class="num_box">
            <img
              src="../assets/images/AIR_RA800-edited.png"
              alt=""
              style="margin: 0 auto; display: flex"
            />
            <div
              @click="showNum1()"
              class="check_button r800-c1"
              :class="showId === 1 ? 'select_button' : ''"
              style="
                position: absolute;
                bottom: 2.5%;
                left: 30.6%;
                background: #fff;
              "
            >
              1
            </div>
            <div
              @click="showNum2()"
              class="check_button r800-c2"
              :class="showId === 2 ? 'select_button' : ''"
              style="
                position: absolute;
                bottom: 2.5%;
                right: 37.2%;
                background: #fff;
              "
            >
              2
            </div>
            <div
              @click="showNum3()"
              class="check_button r800-c3"
              :class="showId === 3 ? 'select_button' : ''"
              style="
                position: absolute;
                top: 27%;
                left: 56.4%;
                background: #fff;
              "
            >
              3
            </div>
          </div>
          <div class="guolv-desc" v-if="showId === 1">
            <p style="font-weight: bold">1 | 初效滤网</p>
            <p style="line-height: 2">
              能过滤5微米以上尘埃粒子，包括大颗粒粉尘、毛屑、花粉、漂浮物等污染物。可多次清洗，重复利用。
            </p>
          </div>
          <div class="guolv-desc" v-if="showId === 2">
            <p style="font-weight: bold">2 | HEPA活性炭滤网</p>
            <p style="line-height: 2">
              HEPA过滤网是一种新型高放空气净化材料，在常温下不需要任何能源，就可以达到除尘
              (99.97％)、杀菌 (99.97％)
              的目的。对于0.3微米或以上的粉尘（烟雾、花粉、灰尘等）吸附率可达99.97％，对枯草菌具有高效杀灭能力，对一般细菌也有很强的抑制作用。能去除各种有害气体，分解吸附甲醛，甲苯、二甲苯、氨等有害物，去除率达到99%以上，其速度快，饱和吸附量大。
            </p>
          </div>
          <div class="guolv-desc" v-if="showId === 3">
            <p style="font-weight: bold">3 | 负离子发生器</p>
            <p style="line-height: 2">
              负离子能使通常带正电荷的室内尘埃、烟雾、细菌相互聚集，使其失去在空气中自由漂浮的能力并迅速降落，从而净化空气。负离子释放对人体健康有益的小粒径负离子。负离子不仅能除尘、净化空气,还能促成人体合成和储存维生素，强化和激活人体的生理活动，因此它被称为「空气维生素」。1000万/cm³的高浓度负离子让您的身体补充充足的「维生素」。
            </p>
          </div>
        </div>
        <!-- 产品特点 -->
        <div
          class="Air-wu-protd"
          v-if="activeName === 'all' || activeName === '3'"
        >
          <div class="prottedian-tit">产品特点</div>
          <div class="prottedian-list">
            <AirProTDTransverse :list="protdList2"></AirProTDTransverse>
          </div>
        </div>
        <!-- 服务介绍 -->
        <div
          class="Air-liu-jieshao"
          v-if="activeName === 'all' || activeName === '4'"
        >
          <div class="fw-jieshao">优质空气服务介绍</div>
          <div class="jieshao-desc">
            Renaud品牌通过免费提供的高效空气净化设备及每6个月一次的免费上门服务，以确保客户的室内空气处于安全的水平，同时亦保证设备一直处于最佳的使用状态。服务内容如下：
          </div>
          <div class="jieshao-list">
            <div class="js-diyi" v-for="(item, index) in jsList" :key="index">
              <img v-lazy="item.url" alt="" />
              <span class="js-titbiaoti">{{ item.jsTit }}</span>
            </div>
          </div>
          <div class="js-diyi-zuihiu">
            <img src="../assets/images/icon/air-js7.png" alt="" />
            <span class="js-titbiaoti-zuihiu"
              >每6个月免费上门ー次维护及保养设备，包括：</span
            >
          </div>
          <ul class="titbiaoti-zuihiu-ul" style="padding-left: 0">
            <li
              class="zuihou-ul0li-tit"
              v-for="(item, index) in fwjsList2"
              :key="index"
            >
              {{ item.title }}
              <!-- <span> {{ item.title }}</span> -->
            </li>
          </ul>
          <ul class="titbiaoti-zuihiu-ul" style="padding-left: 0">
            <li
              class="zuihou-ul0li-tit"
              v-for="(item, index) in fwjsList3"
              :key="index"
            >
              {{ item.title }}
              <!-- <span>{{ item.title }}</span> -->
            </li>
          </ul>
        </div>
        <!-- 规格 -->
        <div
          class="air-qi-guige"
          v-if="activeName === 'all' || activeName === '5'"
        >
          <div class="guige-titbiaoti">规格</div>
          <div class="guige-nr">
            <div class="guige-nr-left">
              <div
                class="cp-mc"
                v-for="(item, index) in guigeLeftList2"
                :key="index"
              >
                <span class="cp-mc-biaoti">{{ item.getit }} </span>
                <span class="cp-mc-shuoming" v-html="item.gename"> </span>
              </div>
            </div>
            <div class="guige-nr-rig">
              <div
                class="cp-mc"
                v-for="(item, index) in guigeRigList2"
                :key="index"
              >
                <span class="cp-mc-biaoti"> {{ item.getit }}</span>
                <span class="cp-mc-shuoming">{{ item.gename }} </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 检测 -->
        <div
          class="air-ba-jiance"
          v-if="activeName === 'all' || activeName === '6'"
        >
          <div class="jiance-titbiaoti">检测</div>
          <div class="jc-desc" style="margin-left: -4px">
            <p>蔚诺800系列空气净化器符合GB/T</p>
            <p>18801-2015空气净化器新国标</p>
          </div>
          <img
            class="add_pic"
            src="../assets/images/icon/air-jiahao.png"
            alt=""
          />
          <div class="jc-pic">
            <!-- <div>
              <div class="jc-desc">
                <p>H1N1及EV71</p>
                <p>检测报告</p>
              </div> -->
            <!-- 图一 -->
            <div class="jctupian">
              <img
                @click="showPic4 = true"
                src="../assets/images/ra800-detection1.png"
                alt=""
                style="width: 160px; height: 240px"
              />
            </div>
            <!-- </div> -->
            <el-dialog title="" :visible.sync="showPic4" class="dialog" center>
              <img
                src="../assets/images/ra800-detection1.png"
                alt=""
                style="width: 95%"
              />
            </el-dialog>

            <!-- <div>
              <div class="jc-desc">
                <p>多种有害气体及细菌</p>
                <p>检测报告(A)</p>
              </div> -->
            <!-- 图二 -->
            <div class="jctupian">
              <img
                @click="showPic5 = true"
                src="../assets/images/ra800-detection2.png"
                alt=""
                style="width: 160px; height: 240px"
              />
            </div>
            <!-- </div> -->
            <el-dialog title="" :visible.sync="showPic5" class="dialog" center>
              <img
                src="../assets/images/ra800-detection2.png"
                alt=""
                style="width: 95%"
              />
            </el-dialog>

            <!-- <div>
              <div class="jc-desc">
                <p>多种有害气体及细菌</p>
                <p>检测报告(B)</p>
              </div> -->
            <!-- 图三 -->
            <div class="jctupian">
              <img
                @click="showPic6 = true"
                src="../assets/images/ra800-detection3.png"
                alt=""
                style="width: 160px; height: 240px"
              />
            </div>
            <!-- </div> -->
            <el-dialog title="" :visible.sync="showPic6" class="dialog" center>
              <img
                src="../assets/images/ra800-detection3.png"
                alt=""
                style="width: 95%"
              />
            </el-dialog>
          </div>
        </div>
        <!-- 过滤配件 -->
        <div
          class="Air-jiu-guolvpj"
          v-if="activeName === 'all' || activeName === '7'"
        >
          <div class="guolvpj-titbiaoti">过滤配件</div>
          <!-- 复合滤网 -->
          <div class="guolvpj-nr">
            <div class="peijian-left">
              <div class="glpj-pic-bj">
                <img
                  src="../assets/images/air-glpj.png"
                  alt=""
                  style="width: 100%"
                />
              </div>
              <div class="glpj-anniu">
                <div class="pj-anniu-zixun" @click="form2()">咨询</div>
                <!-- <div style="margin-top:3%;color:#595757;">Medic Filter</div> -->
              </div>
            </div>
            <div class="peijian-rig">
              <div class="pj-duanluo">
                <div class="pj-smaltit">RA800复合滤网</div>
              </div>
              <div class="pj-duanluo">
                <div class="pj-smaltit" style="font-weight: normal">
                  技术规格
                </div>
                <!-- 横线 -->
                <div class="pj-line"></div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">型号：</span>
                  <span class="cp-mc-shuoming"> RA800-HC</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">滤网数量：</span>
                  <span class="cp-mc-shuoming">2片（HEPA+活性炭复合滤网）</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">HEPA级别：</span>
                  <span class="cp-mc-shuoming"
                    >H12级别（有效过滤99.9% @ 0.3微米颗粒物）</span
                  >
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">建议使用时间：</span>
                  <span class="cp-mc-shuoming">6个月</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">尺寸：</span>
                  <span class="cp-mc-shuoming">41x29.5x6厘米（每一片）</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 其他 -->
        <div
          class="Air-shi-qita"
          v-if="activeName === 'all' || activeName === '8'"
        >
          <div class="qita-titbiaoti">其他</div>
          <div class="">
            <AirQiTaTransverse :list="qiTaList2"></AirQiTaTransverse>
          </div>
        </div>
      </div>
      <!-- 表单 -->
      <div class="air_form" v-if="play == false">
        <!-- 返回按钮 -->
        <div class="form_back" @click="form_back()">返回</div>
        <!-- 标题 -->
        <p class="form_title" v-if="playid == 0">
          咨询：<span>RA800 高效空气净化器</span>
        </p>
        <p class="form_title" v-if="playid == 1">
          咨询：<span>RA800 复合滤网</span>
        </p>

        <!-- 表单 -->
        <div class="form_main">
          <!-- 请选择省份 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-paper.png" alt="" />
            </div>
            <el-select
              v-model="formData1.provinceValue"
              @change="getCity"
              placeholder="请选择省份"
              class="form_input"
              style="margin-left: 0.02rem"
            >
              <el-option
                v-for="(item, index) in provinceArr"
                :key="index"
                :label="item.provinceCn"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <!-- 请选择城市 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-tag.png" alt="" />
            </div>
            <el-select
              v-model="formData1.cityValue"
              placeholder="请选择城市"
              class="form_input"
              no-data-text="无数据"
              style="margin-left: 0.02rem"
            >
              <el-option
                v-for="(item, index) in cityArr"
                :key="index"
                :label="item.cityCn"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 请输入姓名 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-man.png" alt="" />
            </div>
            <el-input
              type="text"
              placeholder="请输入姓名"
              v-model="formData1.nameValue"
              class="form_input"
              :max="5"
            />
          </div>
          <!-- 请输入手机号 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-phone.png" alt="" />
            </div>
            <el-input
              type="text"
              placeholder="请输入手机号"
              v-model="formData1.phoneValue"
              class="form_input"
              id="form_input"
              @blur="phoneRule"
            />
          </div>
          <!-- 邀请码 -->
          <div class="form_box" id="yaoqingma">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-message.png" alt="" />
            </div>
            <!-- <input type="text" placeholder="邀请码" class="form_input" style="padding-left:13px;outline:none;"> -->
            <el-select
              v-model="formData1.code"
              @change="qingKong"
              placeholder="邀请码"
              style="margin-left: 0.03rem"
            >
              <el-option :value="1" label="没有">没有</el-option>
              <el-option :value="2" label="有">有</el-option>
              <!--              <el-option :value="3" label="不清楚">不清楚</el-option>-->
            </el-select>
            <el-select
              v-if="formData1.code === 1"
              v-model="formData1.codeTwo"
              placeholder="选择"
            >
              <el-option :value="1" label="确定没有">确定没有</el-option>
              <el-option :value="2" label="不清楚">不清楚</el-option>
            </el-select>
            <el-input
              v-if="formData1.code === 2"
              v-model="formData1.codeTwo"
              placeholder="请输入邀请码"
              class="margin1"
            ></el-input>
          </div>
          <!-- 提交按钮 -->
          <div class="form_button">
            <div class="button_title" @click="commit2()">提交</div>
            <div class="button_icon" @click="commit2()">
              <img src="../assets/images/icon/play-white.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ---------------------------------- PN-02B/W ---------------------------------- -->
    <div v-show="tabId == 2" class="tabs_one"  v-if="show">
      <!-- 海报图 -->
      <!--      <div class="banner">-->
      <!--        <a-carousel arrows dots=false>-->
      <!--          <div-->
      <!--            slot="prevArrow"-->
      <!--            class="custom-slick-arrow"-->
      <!--            style="left: 10px;zIndex: 1"-->
      <!--          >-->
      <!--            <a-icon type="left-circle" />-->
      <!--          </div>-->
      <!--          <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">-->
      <!--            <a-icon type="right-circle" />-->
      <!--          </div>-->
      <!--          <div class="banner_box">-->
      <!--            &lt;!&ndash; 播放按钮 &ndash;&gt;-->
      <!--            <img class="play_icon" src="../assets/images/icon/play-icon.png" alt="">-->
      <!--            &lt;!&ndash; 背景图 &ndash;&gt;-->
      <!--            <img class="banner_bgimg" style="height:100%;" src="../assets/images/air-pn-banner.png" alt="">-->
      <!--            &lt;!&ndash; 内容 &ndash;&gt;-->
      <!--            <div class="banner_main" style="align-items: center;">-->
      <!--              &lt;!&ndash; 文案 &ndash;&gt;-->
      <!--              <div class="banner_copy1" style="position: absolute;top:17%;left:13%;">-->
      <!--                &lt;!&ndash; LOGO &ndash;&gt;-->
      <!--                <img class="banner_logo" src="../assets/images/icon/air-logo-blue.png" style="margin-bottom:30px;" alt="">-->
      <!--                &lt;!&ndash; 横线 &ndash;&gt;-->
      <!--                <img class="banner_line1" src="../assets/images/graphic-line-blue.png" alt="">-->
      <!--                <p style="color:#001383;margin-top:30px;">主动出击，灭杀空气中的<br>病菌，以及分解有害物</p>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </a-carousel>-->
      <!--      </div>-->
      <div v-if="imgList3.length > 1">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in imgList3" :key="index">
            <!--            <img class="banner" v-lazy="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
            <img
              class="banner"
              @click="tiaoZhuan3(index)"
              v-lazy="
                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                item.imgUrl
              "
              alt=""
            />
            <p
              style="
                margin: 5% 0;
                position: absolute;
                top: 70%;
                color: #fff;
                font-size: 40px;
                left: 10%;
              "
              v-html="item.remarks"
            ></p>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div
            class="swiper-button-prev swiper-button-prev-new"
            slot="button-prev"
          >
            <i class="el-icon-arrow-left"></i>
          </div>
          <div
            class="swiper-button-next swiper-button-next-new"
            slot="button-next"
          >
            <i class="el-icon-arrow-right"></i>
          </div>
        </swiper>
        <!--如果你需要分页-->
        <div class="swiper-pagination" slot="pagination"></div>
        <!--如果需要前进后退按钮-->
        <div class="swiper-button-next2"></div>
        <div class="swiper-button-prev2"></div>
      </div>
      <div v-if="imgList3.length <= 1" class="banner">
        <div v-for="(item, index) in imgList3" :key="index">
          <div
            id=""
            style="
              width: 100%;
              display: flex;
              justify-content: center;
              position: absolute;
              align-items: center;
              height: 100%;
              z-index: 2;
            "
          >
            <img
              @click="showCont"
              src="../assets/images/bofang.png"
              slot="reference"
              class="bfbtn"
            />
          </div>
          <div
            class="banner_box"
            style="display: flex; justify-content: center"
          >
            <div id="">
              <!-- 背景图 -->
              <img
                class="banner_bgimg"
                @click="tiaoZhuan3(index)"
                style="height: 100%; width: 100%"
                src="../assets/images/pn-jt.jpg"
                alt=""
              />

              <div class="propk">
                <div class="media1">
                  <video
                    webkit-playsinline="true"
                    playsinline="true"
                    :autoplay="show2"
                    controls
                    preload="metadata"
                    poster="http://118.89.87.102:8080/jeecg-boot/sys/common/static/pic/PN-02视频图.png"
                    :src="'http://118.89.87.102:8686/' + item.video"
                    v-show="show2"
                    id="videl"
                  ></video>
                  <div class="close-btn" v-show="show2" @click="closeVideo">
                    关闭
                  </div>
                </div>
              </div>
              <!-- 内容 -->
              <div class="banner_main" style="align-items: center">
                <!-- 文案 -->
                <div
                  class="banner_copy1"
                  style="margin-top: -54%; margin-left: -50%; width: 33%"
                >
                  <!-- LOGO -->
                  <img
                    class="banner_logo banner-log-new2"
                    src="../assets/images/icon/air-logo-blue.png"
                    alt=""
                  />
                  <!-- 横线 -->
                  <img
                    class="line"
                    width=""
                    src="../assets/images/graphic-line-blue.png"
                    alt=""
                  />
                  <p style="color: #001383" class="banner-log-new-p">
                    主动出击，灭杀空气中的病菌，以及分解有害物
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="play">
        <!-- 导航栏 -->
        <div class="Air-two-mulu">
          <div class="two-label">
            <el-tabs v-model="activeName">
              <el-tab-pane label="全部" name="all"></el-tab-pane>
              <el-tab-pane label="有关产品" name="1"></el-tab-pane>
              <el-tab-pane label="过滤净化功能" name="2"></el-tab-pane>
              <el-tab-pane label="服务介绍" name="4"></el-tab-pane>
              <el-tab-pane label="规格" name="5"></el-tab-pane>
              <el-tab-pane label="检测" name="6"></el-tab-pane>
              <el-tab-pane label="过滤配件" name="7"></el-tab-pane>
              <el-tab-pane label="其他" name="8"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="two-anniu">
            <div class="two-anniu-anniu" @click="form()">咨询</div>
            <!-- <div class="two-anniu-anniu" @click="goumaiTZ()">购买</div> -->
          </div>
        </div>
        <!-- 有关产品 -->
        <div
          class="Air-san-mlyi"
          v-if="activeName === 'all' || activeName === '1'"
        >
          <div class="mlyi-tit">有关产品</div>
          <div class="mlyi-list yycp-list">
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-m.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">适用面积：10－15m²</span>
            </div>
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-cadr.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">颗粒物：80m³/h</span>
            </div>
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-xj.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title"
                >有效杀灭99.9%以上<br />H1N1及EV71病毒</span
              >
            </div>
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-pdc.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">PDC等离子驱动<br />催化技术</span>
            </div>
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-nano.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">NANO纳米纤维滤网</span>
            </div>
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-hepa.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title"
                >H13级HEPA有效过滤<br />99.97%低至0.3微米颗粒物</span
              >
            </div>
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-wifi.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">红外线粉尘传感器</span>
            </div>
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-four.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">负离子净化：<br />300万ions/cm³</span>
            </div>
            <div class="yycp yycp-second">
              <img
                src="../assets/images/icon/air-pad.png"
                alt=""
                style="width: 20%"
              />
              <span class="yycp-title">滤网更换提醒</span>
            </div>
          </div>
        </div>
        <!-- 等离子纳米空气净化 -->
        <div
          class="Air-qi-guolv"
          v-if="activeName === 'all' || activeName === '2'"
        >
          <div
            class="guolv-tit"
            style="width: 15%; color: #0d1d41; padding-top: 10px"
          >
            等离子纳米空气净化
          </div>
          <img
            src="../assets/images/air-pn-pic.png"
            alt=""
            style="margin: 0 auto; display: flex; margin-bottom: 10px"
          />
          <div class="guolv-desc" style="border: none">
            <!-- 标题 -->
            <p
              style="
                font-weight: bold;
                margin: 20px 0 40px 0;
                color: #0d1d41;
                text-align: center;
              "
            >
              等离子驱动催化技术（PDC）+ 纳米纤维滤网（NANO）
            </p>
            <!-- 正文 -->
            <p class="text_main" style="">
              <span>· </span
              >含有光触媒的纳米纤维滤网，非常有效阻隔空气颗粒，困住空气中的病毒、细菌及挥发性有机化合物（VOCs），再由PDC杀灭或分解，减低二次污染
            </p>
            <p class="text_main" style="font-weight: bold">
              <span>· </span
              >主动释放活性氧化物，分解四周有害物，转化成水和二氧化碳等无害物
            </p>
            <p class="text_main"><span>· </span>超幼细及非常高的表面面积</p>
            <p class="text_main">
              <span style="padding-left: 2%"> → </span
              >非常有效阻隔空气颗粒，困住空气中的病毒、细菌及挥发性有机化合物（VOCs）
            </p>
            <p class="text_main">
              <span style="padding-left: 2px">· </span
              >PDC以等离子体去激活纳米纤维滤网内的光触媒，产生出活性的氧化物
            </p>
            <p class="text_main">
              <span style="padding-left: 2%"> → </span
              >透过氧化作用，破坏病菌表面组织及DNA，发挥杀菌效果，同时转化其他空气中的有害物成水和二氧化碳等无害物
            </p>
            <p class="text_main" style="padding-left: 5.7%"></p>
          </div>
        </div>
        <!-- 服务介绍 -->
        <div
          class="Air-liu-jieshao"
          v-if="activeName === 'all' || activeName === '4'"
          style="background-color: #d6d7d7"
        >
          <div class="fw-jieshao">优质空气服务介绍</div>
          <div class="jieshao-desc">
            Renaud品牌通过免费提供的高效空气净化设备及每6个月一次的免费上门服务，以确保客户的室内空气处于安全的水平，同时亦保证设备一直处于最佳的使用状态。服务内容如下：
          </div>
          <div class="jieshao-list">
            <div class="js-diyi" v-for="(item, index) in jsList2" :key="index">
              <img v-lazy="item.url" alt="" />
              <span class="js-titbiaoti">{{ item.jsTit }}</span>
            </div>
          </div>
        </div>
        <!-- 规格 -->
        <div
          class="air-qi-guige"
          v-if="activeName === 'all' || activeName === '5'"
          style="padding-bottom: 30px"
        >
          <div class="guige-titbiaoti">规格</div>
          <div class="guige-nr">
            <div class="guige-nr-left">
              <div
                class="cp-mc"
                v-for="(item, index) in guigeLeftList3"
                :key="index"
              >
                <span class="cp-mc-biaoti">{{ item.getit }} </span>
                <span class="cp-mc-shuoming" style="width: 80%"
                  >{{ item.gename }}
                </span>
              </div>
            </div>
            <div class="guige-nr-rig" style="width: 45%">
              <div
                class="cp-mc"
                v-for="(item, index) in guigeRigList3"
                :key="index"
              >
                <span class="cp-mc-biaoti"> {{ item.getit }}</span>
                <span class="cp-mc-shuoming" style="width: 80%"
                  >{{ item.gename }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 检测 -->
        <div
          class="air-ba-jiance"
          v-if="activeName === 'all' || activeName === '6'"
        >
          <div class="jiance-titbiaoti">检测</div>
          <!-- <div class="jc-desc">
                      <p>蔚诺PN系列空气净化器符合GB/T</p>
                      <p>18801-2015空气净化器新国标</p>
                    </div> -->
          <!-- <img class="add_pic" src="../assets/images/icon/air-jiahao.png" alt="" /> -->
          <div class="jc-pic">
            <div class="jc-ju" style="width: 33%">
              <div class="jc-desc">
                <p>H1N1及EV71</p>
                <p>检测报告</p>
              </div>

              <!-- 图一 -->
              <div class="jctupian">
                <img
                  @click="showPic7 = true"
                  src="../assets/images/pn-111.jpg"
                  alt=""
                  style="width: 160px; height: 240px"
                />
              </div>
            </div>
            <el-dialog title="" :visible.sync="showPic7" class="dialog" center>
              <img
                src="../assets/images/pn-111.jpg"
                alt=""
                style="width: 95%"
              />
            </el-dialog>

            <div style="width: 33%">
              <div class="jc-desc">
                <p>多种有害气体及细菌</p>
                <p>检测报告(A)</p>
              </div>
              <!-- 图二 -->
              <div class="jctupian">
                <!--                            <p class="pn-font">H1N1及EV71<br>检测报告</p>-->
                <img
                  @click="showPic8 = true"
                  src="../assets/images/pn-222.jpg"
                  alt=""
                  style="width: 160px; height: 240px"
                />
              </div>
            </div>
            <el-dialog title="" :visible.sync="showPic8" class="dialog" center>
              <img
                src="../assets/images/pn-222.jpg"
                alt=""
                style="width: 95%"
              />
            </el-dialog>

            <div style="width: 33%">
              <div class="jc-desc">
                <p>多种有害气体及细菌</p>
                <p>检测报告(B)</p>
              </div>
              <!-- 图三 -->
              <div class="jctupian">
                <!--                            <p class="pn-font">H1N1及EV71<br>检测报告</p>-->
                <img
                  @click="showPic9 = true"
                  src="../assets/images/pn-333.jpg"
                  alt=""
                  style="width: 160px; height: 240px"
                />
              </div>
            </div>
            <el-dialog title="" :visible.sync="showPic9" class="dialog" center>
              <img
                src="../assets/images/pn-333.jpg"
                alt=""
                style="width: 95%"
              />
            </el-dialog>
            <!-- 箭头右 -->
            <!--                        <img class="pn-arrow-pic" src="../assets/images/icon/arrow-right-blue.png" alt="">-->
          </div>
        </div>
        <!-- 过滤配件 -->
        <div
          class="Air-jiu-guolvpj"
          v-if="activeName === 'all' || activeName === '7'"
        >
          <div class="guolvpj-titbiaoti">过滤配件</div>
          <!-- 复合滤网 -->
          <div class="guolvpj-nr">
            <div class="peijian-left">
              <div class="glpj-pic-bj">
                <img
                  src="../assets/images/pn-pic1.png"
                  alt=""
                  style="width: 100%"
                />
              </div>
              <div class="glpj-anniu">
                <div class="pj-anniu-zixun" @click="form2()">咨询</div>
                <!-- <div style="margin-top:3%;color:#595757;">Medic Filter</div> -->
              </div>
            </div>
            <div class="peijian-rig">
              <div class="pj-duanluo">
                <div class="pj-smaltit">H13 高效HEPA复合滤网 (PN-02B/W)</div>
              </div>
              <div class="pj-duanluo">
                <div class="pj-smaltit" style="font-weight: normal">
                  技术规格
                </div>
                <!-- 横线 -->
                <div class="pj-line"></div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">型号：</span>
                  <span class="cp-mc-shuoming"> PNHSCW</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">滤网数量：</span>
                  <span class="cp-mc-shuoming"
                    >1片（HEPA、活性炭、银离子涂层复合滤网）</span
                  >
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">HEPA级别：</span>
                  <span class="cp-mc-shuoming"
                    >H13级别（有效过滤99.97% @ 0.3微米颗粒物）</span
                  >
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">建议使用时间：</span>
                  <span class="cp-mc-shuoming">6个月</span>
                </div>
                <div class="cp-mc">
                  <span class="cp-mc-biaotigg">尺寸：</span>
                  <span class="cp-mc-shuoming">20.5x18x4厘米</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 其他 -->
        <!--                <div class="Air-shi-qita" v-if="activeName === 'all' || activeName === '8'">-->
        <!--                    <div class="qita-titbiaoti">其他</div>-->
        <!--                    <div class="">-->
        <!--                        <AirQiTaTransverse :list="qiTaList3"></AirQiTaTransverse>-->
        <!--                    </div>-->
        <!--                </div>-->
      </div>
      <!-- 表单 -->
      <div class="air_form" v-if="play == false">
        <!-- 返回按钮 -->
        <div class="form_back" @click="form_back()">返回</div>
        <!-- 标题 -->
        <p class="form_title" v-if="playid == 0">
          咨询：<span>PN-02B/W 等离子纳米空气净化器</span>
        </p>
        <p class="form_title" v-if="playid == 1">
          咨询：<span>H13 高效HEPA复合滤网 (PN-02B/W)</span>
        </p>
        <!-- 表单 -->
        <div class="form_main">
          <!-- 请选择省份 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-paper.png" alt="" />
            </div>
            <el-select
              v-model="formData1.provinceValue"
              @change="getCity"
              placeholder="请选择省份"
              class="form_input"
              style="margin-left: 0.02rem"
            >
              <el-option
                v-for="(item, index) in provinceArr"
                :key="index"
                :label="item.provinceCn"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <!-- 请选择城市 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-tag.png" alt="" />
            </div>
            <el-select
              v-model="formData1.cityValue"
              placeholder="请选择城市"
              class="form_input"
              no-data-text="无数据"
              style="margin-left: 0.02rem"
            >
              <el-option
                v-for="(item, index) in cityArr"
                :key="index"
                :label="item.cityCn"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 请输入姓名 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-man.png" alt="" />
            </div>
            <el-input
              type="text"
              maxlength="50"
              placeholder="请输入姓名"
              v-model="formData1.nameValue"
              class="form_input"
              :max="5"
            />
          </div>
          <!-- 请输入手机号 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-phone.png" alt="" />
            </div>
            <el-input
              type="text"
              placeholder="请输入手机号"
              v-model="formData1.phoneValue"
              class="form_input"
              @blur="phoneRule"
            />
          </div>
          <!-- 邀请码 -->
          <div class="form_box">
            <div class="img-wrap">
              <img src="../assets/images/icon/icon-message.png" alt="" />
            </div>
            <!-- <input type="text" placeholder="邀请码" class="form_input" style="padding-left:13px;outline:none;"> -->
            <el-select
              v-model="formData1.code"
              @change="qingKong"
              placeholder="邀请码"
              style="margin-left: 0.03rem"
            >
              <el-option :value="1" label="没有">没有</el-option>
              <el-option :value="2" label="有">有</el-option>
              <!--              <el-option :value="3" label="不清楚">不清楚</el-option>-->
            </el-select>
            <el-select
              v-if="formData1.code === 1"
              v-model="formData1.codeTwo"
              placeholder="选择"
            >
              <el-option :value="1" label="确定没有">确定没有</el-option>
              <el-option :value="2" label="不清楚">不清楚</el-option>
            </el-select>
            <el-input
              v-if="formData1.code === 2"
              v-model="formData1.codeTwo"
              placeholder="请输入邀请码"
              class="margin1"
            ></el-input>
          </div>
          <!-- 提交按钮 -->
          <div class="form_button">
            <div class="button_title" @click="commit3()">提交</div>
            <div class="button_icon" @click="commit3()">
              <img src="../assets/images/icon/play-white.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AirProTDTransverse from "@/components/AirProTDTransverse";
import AirQiTaTransverse from "@/components/AirQiTaTransverse";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Axios from "axios";

export default {
  components: {
    Header,
    Footer,
    AirProTDTransverse,
    AirQiTaTransverse,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      fullscreen: false,
      agentAccount: [],
      paused: false,
      show1: true, //视频状态
      show2: false,
      mask: false,
      mask1: false,
      typeList: [],
      imgList4: [],
      swiperOption: {
        loop: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      showId: 1,
      showPic1: false,
      showPic2: false,
      showPic3: false,
      showPic4: false,
      showPic5: false,
      showPic6: false,
      showPic7: false,
      showPic8: false,
      showPic9: false,
      phoneR: false,
      imgList1: [],
      imgList2: [],
      imgList3: [],
      tabList: [
        {
          title: "RA 488",
          main: "高效空气净化器",
        },
        {
          title: "RA 800",
          main: "高效空气净化器",
        },
        // {
        //   title: "PN-02B/W",
        //   main: "等离子纳米空气净化器",
        // },
      ],
      tabId: 0,
      activeName: "all",
      play: true,
      playid: 1,
      value1: "",
      value2: "",
      provinceArr: [],
      cityArr: [],
      formData1: {
        modelsValue: "", //机型
        provinceValue: undefined, //省份
        cityValue: undefined, //城市
        customerValue: undefined, //客户
        nameValue: "", //姓名
        adressValue: "", //详情地址
        phoneValue: "", //手机号
        serviceAddress: "", //服务地址
        eamilValue: "", //电子邮箱
        companyValue: "", //公司名称
        codeOne: undefined,
        codeTwo: undefined,
        code: "",
      },
      // 488产品特点
      protdList: [
        {
          url: require("../assets/images/air-protd5.png"),
          span: "APP远程控制机器",
          title:
            "打开/关闭机器；打开/关闭负离子功能；可远程调整风速和设置计时器模式等",
        },
        {
          url: require("../assets/images/air-protd1.png"),
          span: "自然蒸发加湿功能",
          title: "不会使室内湿度过高，高档开机1小时增加湿度为10-15%",
        },
        {
          url: require("../assets/images/air-protd4.png"),
          span: "童锁",
          title: "自动禁止显示面板上的所有按钮，确保您的孩子安全",
        },
        {
          url: require("../assets/images/air-product5.png"),
          span: "PM2.5显示",
          title: "实时监测您家或办公室的空气质量",
        },
      ],
      // 800产品特点
      protdList2: [
        {
          url: require("../assets/images/air-protd5-1.png"),
          span: "APP远程控制机器",
          title:
            "打开/关闭机器；打开/关闭负离子功能；可远程调整风速和设置计时器模式等",
        },
        {
          url: require("../assets/images/air-protd6.png"),
          span: "童锁",
          title: "自动禁用显示面板上的所有按钮，确保您的孩子安全",
        },
        {
          url: require("../assets/images/air-protd7.png"),
          span: "PM2.5显示",
          title: "实时监测您家或办公室的空气质量",
        },
      ],
      // 488/800服务介绍
      jsList: [
        {
          url: require("../assets/images/icon/air-js1.png"),
          jsTit: "灵活合同周期（12/24/36个月）",
        },
        {
          url: require("../assets/images/icon/air-js2.png"),
          jsTit: "免费提供高效空气净化设备",
        },
        {
          url: require("../assets/images/icon/air-js3.png"),
          jsTit: "弹性付款方式",
        },
        {
          url: require("../assets/images/icon/air-js4.png"),
          jsTit: "免费送货及安装（仅限本市）",
        },
        {
          url: require("../assets/images/icon/air-js5.png"),
          jsTit: "智能手机APP远程管理设备",
        },
        {
          url: require("../assets/images/icon/air-js6.png"),
          jsTit: "免费室内空气质量检测",
        },
      ],
      // PN服务介绍
      jsList2: [
        {
          url: require("../assets/images/icon/air-js1.png"),
          jsTit: "灵活合同周期（12/24/36个月）",
        },
        {
          url: require("../assets/images/icon/air-js2.png"),
          jsTit: "免费提供高效空气净化设备",
        },
        {
          url: require("../assets/images/icon/air-js3.png"),
          jsTit: "弹性付款方式",
        },
        {
          url: require("../assets/images/icon/air-js4.png"),
          jsTit: "免费送货及安装（仅限本市）",
        },
        {
          url: require("../assets/images/icon/air-js7.png"),
          jsTit:
            "每6个月免费上门一次维护及保养设备，包括：机身清洁及更换设备滤网",
        },
        {
          url: require("../assets/images/icon/air-js6.png"),
          jsTit: "免费室内空气质量检测",
        },
      ],
      // 488服务介绍
      fwjsList: [
        {
          title: "机身清洁",
        },
        {
          title: "维护颗粒物感应器",
        },
        {
          title: "水箱清洁及消毒",
        },
        {
          title: "负离子发生器保养和清洁",
        },
        {
          title: "更换设备滤网",
        },
        {
          title: "更换加湿器滤网",
        },
      ],
      // 800服务介绍
      fwjsList2: [
        {
          title: "机身清洁",
        },
        {
          title: "维护颗粒物感应器",
        },
      ],
      fwjsList3: [
        {
          title: "负离子发生器保养和清洁",
        },
        {
          title: "更换设备滤网",
        },
      ],
      // 488规格
      guigeLeftList: [
        {
          getit: "产品名称",
          gename: "蔚诺空气488系列",
        },
        {
          getit: "适用面积",
          gename: "34 - 58 m²",
        },
        {
          getit: "CADR颗粒物",
          gename: "488 m³/ h",
        },
        {
          getit: "CADR甲醛",
          gename: "100 m³/ h",
        },
        {
          getit: "CCM颗粒物",
          gename: "P4",
        },
        {
          getit: "CCM甲醛",
          gename: "F4",
        },
        {
          getit: "能效等级",
          gename: "高效级",
        },
        {
          getit: "HEPA级别",
          gename: "H13(<span class='hepa_text'>99.97% @ 0.3 um</span>)",
        },
      ],
      guigeRigList: [
        {
          getit: "除菌率",
          gename: "99.98%白色葡萄球菌",
        },
        {
          getit: "负离子净化",
          gename: "1000万 离子/cm³",
        },
        {
          getit: "噪音",
          gename: "38 - 68.7 dB(A) ",
        },
        {
          getit: "额定电压 ",
          gename: "220 - 240 V",
        },
        {
          getit: "额定频率",
          gename: "50Hz / 60Hz",
        },
        {
          getit: " 额定功率",
          gename: " 95W ",
        },
        {
          getit: "产品尺寸",
          gename: "400 x 230 x 620mm",
        },
        {
          getit: "产品净重",
          gename: "10.8 kg",
        },
      ],
      // 800规格
      guigeLeftList2: [
        {
          getit: "产品名称",
          gename: "蔚诺空气800系列",
        },
        {
          getit: "适用面积",
          gename: "56 - 96 m²",
        },
        {
          getit: "CADR颗粒物",
          gename: "800 m³/ h",
        },
        {
          getit: "CADR甲醛",
          gename: "400 m³/ h",
        },
        {
          getit: "CCM颗粒物",
          gename: "P4",
        },
        {
          getit: "CCM甲醛",
          gename: "F4",
        },
        {
          getit: "能效等级",
          gename: "高效级",
        },
        {
          getit: "HEPA级别",
          gename: "H13 (<span class='hepa_text'>99.97% @ 0.3 um</span>)",
        },
        {
          getit: "除菌率",
          gename: "99.99%白色葡萄球菌",
        },
        {
          getit: "负离子净化",
          gename: "1000万 离子/cm³",
        },
      ],
      guigeRigList2: [
        {
          getit: "噪音",
          gename: "40 - 65.9 dB(A) ",
        },
        {
          getit: "轮子",
          gename: "是",
        },
        {
          getit: "更换滤网警报",
          gename: "是",
        },
        {
          getit: "红外线传感器",
          gename: "是",
        },
        {
          getit: "额定电压 ",
          gename: "220 - 240 V",
        },
        {
          getit: "额定频率",
          gename: "50Hz / 60Hz",
        },
        {
          getit: " 额定功率",
          gename: " 85W ",
        },
        {
          getit: "产品尺寸",
          gename: "400 x 400 x 665mm",
        },
        {
          getit: "产品净重",
          gename: "14.0 kg",
        },
      ],
      // pn规格
      guigeLeftList3: [
        {
          getit: "型号：",
          gename: "PN-02B/W",
        },
        {
          getit: "机身颜色：",
          gename: "白色或黑色",
        },
        {
          getit: "操控：",
          gename: "遥控版",
        },
        {
          getit: "输入功率：",
          gename: "DC 12V",
        },
        {
          getit: "额定电压：",
          gename: "100 ~ 240V",
        },
      ],
      guigeRigList3: [
        {
          getit: "额定功率：",
          gename: "12W",
        },
        {
          getit: "产品尺寸：",
          gename: "215(W)x 240(H) x 138(D) mm",
        },
        {
          getit: "产品重量：",
          gename: "2.87 kg",
        },
        {
          getit: "风速设置：",
          gename: "低、中、高",
        },
      ],
      // 488其他
      qiTaList: [
        {
          url: "RA488更换滤网1.mp4",
          title: "RA488怎样安装滤网",
          icon: require("../assets/images/icon/play.png"),
          fengMian:
            "http://118.89.87.102:8080/jeecg-boot/sys/common/static/pic/RA488更换滤网 视频图.png",
        },
        {
          url: "RA488屏幕解释及APP安装1.mp4",
          title: "RA488屏幕解释及APP安装",
          icon: require("../assets/images/icon/play.png"),
          fengMian:
            "http://118.89.87.102:8080/jeecg-boot/sys/common/static/pic/RA488app视频图.png",
        },
        {
          url: require("../assets/images/AirRA488.png"),
          title: "下载说明书",
          icon: require("../assets/images/icon/dl.png"),
          xiazai: "RA488",
        },
      ],
      // 800其他
      qiTaList2: [
        {
          url: "RA800更换滤网1.mp4",
          title: "RA800怎样安装滤网",
          icon: require("../assets/images/icon/play.png"),
          fengMian:
            "http://118.89.87.102:8080/jeecg-boot/sys/common/static/pic/RA800更换滤网视频图.png",
        },
        {
          url: "RA800屏幕解释及App安装1.mp4",
          title: "RA800屏幕解释及APP安装",
          icon: require("../assets/images/icon/play.png"),
          fengMian:
            "http://118.89.87.102:8080/jeecg-boot/sys/common/static/pic/RA800app视频图.png",
        },
        {
          url: require("../assets/images/AirRA800.png"),
          title: "下载说明书",
          icon: require("../assets/images/icon/dl.png"),
          xiazai: "RA800",
        },
      ],
      // PN其他
      qiTaList3: [
        {
          url: require("../assets/images/air-protd1-1.png"),
          title: "PN怎样安装滤网",
          icon: require("../assets/images/icon/play.png"),
        },
        {
          url: require("../assets/images/air-protd2.png"),
          title: "PN怎样连接Wi-Fi",
          icon: require("../assets/images/icon/play.png"),
        },
        {
          url: require("../assets/images/air-protd3.png"),
          title: "下载说明书",
          icon: require("../assets/images/icon/dl.png"),
        },
      ],
      p: false,
      p2: false,
    };
  },
  mounted: function () {
    this.getshengfen();
    if (this.$route.params.tabId != undefined) {
      this.tabId = this.$route.params.tabId;
    } else {
      // this.key = String(1)
    }
    this.getImagesUrl1();
    this.getImagesUrl2();
    this.getImagesUrl3();
    this.getAgentAccount();
    // this.tiaoZhuan();

    // 添加键盘Esc事件
    const vm = this;
    window.onresize = function () {
      if (!vm.checkFull() && vm.tabId == 2 && vm.fullscreen) {
        vm.closeVideo();
        vm.fullscreen = false;
      }
    };
  },
  methods: {
    getAgentAccount() {
      let that = this;
      Axios.get(
        `${this.api.ip}/jeecg-boot/h5/H5Controller2/getAgentAccount`
      ).then((res) => {
        if (res.data.success === true) {
          that.agentAccount = res.data.result;
        }
      });
    },
    qingKong(e) {
      let that = this;
      if (that.formData1.codeTwo) {
        that.formData1.codeTwo = null;
      }
      that.formData1.code = e;
    },
    showCont() {
      this.mask = !this.mask;
      this.show1 = !this.show1;
      this.show2 = !this.show2;
      let videL = document.querySelector("#videl");
      if (this.mask) {
        videL.play();
      } else {
        videL.pause();
      }

      let openmask = document.querySelector("#mask");
      let imgbtn = document.querySelector(".bfbtn");
      if (this.mask) {
        imgbtn.onclick = function () {
          openmask.style.dispaly = "block";
        };
      }
      if (this.mask1) {
        openmask.onclick = function () {
          openmask.style.dispaly = "none";
        };
      }

      // this.fullScreen();
    },

    videoFunc() {
      this.mask = !this.mask;
      this.show1 = !this.show1;
      this.show2 = !this.show2;
      let videL = document.querySelector("#videl");
      if (this.mask) {
        videL.play();
      } else {
        videL.pause();
      }

      let openmask = document.querySelector("#mask");
      let imgbtn = document.querySelector(".bfbtn");
      if (this.mask) {
        imgbtn.onclick = function () {
          openmask.style.dispaly = "block";
        };
      }
      if (this.mask1) {
        openmask.onclick = function () {
          openmask.style.dispaly = "none";
        };
      }

      this.fullscreen = true;
    },

    //全屏
    fullScreen() {
      //var element= document.documentElement; //若要全屏页面中div，var element= document.getElementById("divID");
      var element = document.querySelector("#videl");

      //IE 10及以下ActiveXObject
      if (window.ActiveXObject) {
        var WsShell = new ActiveXObject("WScript.Shell");
        WsShell.SendKeys("{F11}");
        //写全屏后的执行函数
        this.videoFunc();
      }
      //HTML W3C 提议
      else if (element.requestFullScreen) {
        element.requestFullScreen();
        //写全屏后的执行函数
        this.videoFunc();
      }
      //IE11
      else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
        //写全屏后的执行函数
        this.videoFunc();
      }
      // Webkit (works in Safari5.1 and Chrome 15)
      else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
        //写全屏后的执行函数
        this.videoFunc();
      }
      // Firefox (works in nightly)
      else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
        //写全屏后的执行函数
        this.videoFunc();
      }
    },

    //退出全屏
    fullExit() {
      this.mask = !this.mask;
      this.show1 = !this.show1;
      this.show2 = !this.show2;
      let videL = document.querySelector("#videl");
      videL.pause();

      return;
      //var element= document.documentElement;//若要全屏页面中div，var element= document.getElementById("divID");
      var element = document.getElementById("#videl");
      //IE ActiveXObject
      if (window.ActiveXObject) {
        var WsShell = new ActiveXObject("WScript.Shell");
        WsShell.SendKeys("{F11}");
        //写退出全屏后的执行函数
      }
      //HTML5 W3C 提议
      else if (element.requestFullScreen) {
        document.exitFullscreen();
        //写退出全屏后的执行函数
      }
      //IE 11
      else if (element.msRequestFullscreen) {
        document.msExitFullscreen();
        //写退出全屏后的执行函数
      }
      // Webkit (works in Safari5.1 and Chrome 15)
      else if (element.webkitRequestFullScreen) {
        document.webkitCancelFullScreen();
        //写退出全屏后的执行函数
      }
      // Firefox (works in nightly)
      else if (element.mozRequestFullScreen) {
        document.mozCancelFullScreen();
        //写退出全屏后的执行函数
      }
    },

    //关闭视频
    closeVideo() {
      this.mask = !this.mask;
      this.show1 = !this.show1;
      this.show2 = !this.show2;
      let videL = document.querySelector("#videl");
      videL.pause();
    },

    checkFull() {
      //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
      //火狐浏览器
      var isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        //谷歌浏览器及Webkit内核浏览器
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },

    // tiaoZhuan(){
    //   var that = this;
    //   let setId = this.$route.query.setId;
    //   if (setId === undefined){
    //     that.tabId = 0
    //   }else {
    //     that.tabId = Number(setId)
    //   }
    // },
    // banner点击页面跳转
    tiaoZhuan1(val) {
      var that = this;
      if (that.imgList1[val].lujing === null) {
        return;
      }
      window.location.href = that.imgList1[val].lujing;
    },
    // banner点击页面跳转
    tiaoZhuan2(val) {
      var that = this;
      if (that.imgList2[val].lujing === null) {
        return;
      }
      window.location.href = that.imgList2[val].lujing;
    },
    // banner点击页面跳转
    tiaoZhuan3(val) {
      var that = this;
      if (that.imgList3[val].lujing === null) {
        return;
      }
      window.location.href = that.imgList3[val].lujing;
    },
    phoneRule() {
      var that = this;
      if (that.formData1.phoneValue.length === 0) {
        that.phoneR = false;
        return;
      }
      let rule = /^1[3456789]\d{9}$/;
      if (!rule.test(that.formData1.phoneValue)) {
        this.$message.error("请输入正确的手机号！", 1);
      } else {
        that.phoneR = true;
      }
    },
    getImagesUrl1() {
      var that = this;
      var url =
        "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getBannerImages?location=" +
        108 +
        "&category=" +
        119;
      // var url = "http://192.168.71.1:8082/jeecg-boot/h5/h5Controller/getBannerImages?location="+108+"&category="+119;
      Axios.get(url).then((res) => {
        if (res.data.success === true) {
          for (let i = 0; i < res.data.result.length; i++) {
            that.imgList1.push({
              lujing: res.data.result[i].backup1,
              imgUrl: res.data.result[i].picUrl,
              remarks: res.data.result[i].remarks,
              video: res.data.result[i].backup2,
            });
          }
        }
      });
    },
    getImagesUrl2() {
      var that = this;
      // var url = "http://192.168.71.1:8082/jeecg-boot/h5/h5Controller/getBannerImages?location="+108+"&category="+120;
      var url =
        "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getBannerImages?location=" +
        108 +
        "&category=" +
        120;
      Axios.get(url).then((res) => {
        if (res.data.success === true) {
          for (let i = 0; i < res.data.result.length; i++) {
            that.imgList2.push({
              lujing: res.data.result[i].backup1,
              imgUrl: res.data.result[i].picUrl,
              remarks: res.data.result[i].remarks,
              video: res.data.result[i].backup2,
            });
          }
        }
      });
    },
    getImagesUrl3() {
      var that = this;
      var url =
        "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getBannerImages?location=" +
        108 +
        "&category=" +
        121;
      // var url = "http://192.168.71.1:8082/jeecg-boot/h5/h5Controller/getBannerImages?location="+108+"&category="+121;
      Axios.get(url).then((res) => {
        if (res.data.success === true) {
          for (let i = 0; i < res.data.result.length; i++) {
            that.imgList3.push({
              lujing: res.data.result[i].backup1,
              imgUrl: res.data.result[i].picUrl,
              remarks: res.data.result[i].remarks,
              video: res.data.result[i].backup2,
            });
          }
        }
      });
    },
    toAirForm() {
      this.$router.push("/airForm");
    },
    getshengfen() {
      var that = this;
      var url =
        "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getWyProvince";
      // var url =  "http://192.168.1.120:8082/jeecg-boot/h5/h5Controller/getWyProvince";
      Axios.get(url).then((res) => {
        if (res.data.success == true) {
          that.provinceArr = res.data.result;
        }
      });
    },
    // 获取城市
    getCity() {
      this.formData1.cityValue = undefined;
      var that = this;
      var data = {
        provinceId: that.formData1.provinceValue,
      };
      var url =
        "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getWyCity?provinceId=" +
        data.provinceId;
      // var url = "http://192.168.1.120:8082/jeecg-boot/h5/h5Controller/getWyCity?provinceId="+data.provinceId;
      Axios.get(url).then((res) => {
        if (res.data.success == true) {
          that.cityArr = res.data.result;
        }
      });
    },
    // 返回按钮
    form_back() {
      this.play = true; //取反
    },
    // 资讯按钮
    form() {
      this.play = false; //取反
      this.playid = 0;
    },
    form2() {
      this.play = !this.play; //取反
      this.playid = 1;
      window.scrollTo(0, 600);
    },
    form3() {
      this.play = !this.play; //取反
      this.playid = 2;
      window.scrollTo(0, 600);
    },
    showNum1() {
      this.showId = 1;
    },
    showNum2() {
      this.showId = 2;
    },
    showNum3() {
      this.showId = 3;
    },
    showNum4() {
      this.showId = 4;
    },
    showNum5() {
      this.showId = 5;
    },
    showNum6() {
      this.showId = 6;
    },
    showNum7() {
      this.showId = 7;
    },
    commit1() {
      this.typeList = [119, 118, 122];
      this.commit();
    },
    commit2() {
      this.typeList = [120, 123];
      this.commit();
    },
    commit3() {
      this.typeList = [121, 124];
      this.commit();
    },
    commit() {
      if (!this.formData1.provinceValue) {
        this.$message.error("省份选中不能为空！", 1);
        return false;
      }
      if (!this.formData1.cityValue) {
        this.$message.error("城市选中不能为空！", 1);
        return false;
      }
      if (!this.formData1.nameValue) {
        this.$message.error("姓名不能为空！", 1);
        return false;
      }
      if (!this.formData1.phoneValue || this.phoneR === false) {
        this.$message.error("请输入正确的手机号！", 1);
        return false;
      }
      if (!this.formData1.codeTwo) {
        this.$message.error("邀请码不能为空！", 1);
        return false;
      }
      if (
        this.formData1.codeTwo &&
        this.formData1.codeTwo !== 1 &&
        this.formData1.codeTwo !== 2
      ) {
        if (this.agentAccount.indexOf(this.formData1.codeTwo) === -1) {
          this.$message.error("邀请码无效！", 1);
          return false;
        }
      }
      // if (this.phoneR === false){
      //     this.$message.error("请输入正确的手机号！",1)
      //   return false
      // }
      // if (this.formData1.codeTwo < 0){
      //   this.formData1.codeTwo = undefined
      // }
      var data = {
        consultingId: this.typeList[this.playid],
        provinceId: this.formData1.provinceValue,
        cityId: this.formData1.cityValue,
        companyNameCn: this.formData1.nameValue,
        phone: this.formData1.phoneValue,
        inviteCode: this.formData1.codeTwo,
      };
      var url =
        "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/addWyWCustomerConsultation";
      Axios.post(url, data).then((res) => {
        if (res.data.success == true) {
          this.$message.info("安排成功", 1);
          this.formData1 = {
            modelsValue: "", //机型
            provinceValue: undefined, //省份
            cityValue: undefined, //城市
            customerValue: undefined, //客户
            nameValue: "", //姓名
            adressValue: "", //详情地址
            phoneValue: "", //手机号
            serviceAddress: "", //服务地址
            eamilValue: "", //电子邮箱
            codeOne: undefined,
            codeTwo: undefined,
            companyValue: "", //公司名称
          };
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
body {
  width: 100% !important;
}
.air {
  width: 100% !important;
}

.swiper-button-next,
.swiper-button-prev {
  background-image: none !important;
  // width: 50px;
  // height: 50px;
  background: #9f9fa0a6 !important;
  border-radius: 50%;
  content: ">";
  color: white;
  line-height: 50px;
  text-align: center;
}

/deep/ .el-select__caret {
  font-size: 22px !important;
  color: #183075 !important;
}

/deep/ .el-input__suffix {
  right: 0.126042rem !important;
}

.propk {
  z-index: 9;
  width: 50px;
  position: absolute;
  top: 44%;
  text-align: center;
}

.banner .bfbtn {
  width: 110px !important;
  height: 70px;
  cursor: pointer;
}

// ---------------------------- 标签栏 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
  .swiper-button-prev-new {
    width: 88px;
    height: 88px;
    line-height: 88px !important;
    margin-top: -44px;
    background-size: 88px 88px;
    font-size: 44px;
  }
  .swiper-button-next-new {
    width: 88px;
    height: 88px;
    line-height: 88px !important;
    font-size: 44px;

    margin-top: -44px;
    background-size: 88px 88px;
  }
  .cp-mc-biaoti_left {
    width: 40% !important;
  }
  .margin {
    flex: 1 1 0%;
  }
  .margin1 {
    margin-left: 1.8%;
  }
  .banner-bkg {
    height: 890px;
  }
  // 按钮位置
  .anniu-2 {
    position: absolute;
    top: 19.9%;
    left: 38.7%;
    background: #fff;
  }
  .anniu-4 {
    position: absolute;
    top: 19.9%;
    left: 51.7%;
    background: #fff;
  }
  .anniu-6 {
    position: absolute;
    top: 19.9%;
    left: 64.7%;
    background: #fff;
  }
  .anniu-1 {
    position: absolute;
    bottom: 5.5%;
    left: 32.1%;
    background: #fff;
  }
  .anniu-3 {
    position: absolute;
    bottom: 5.5%;
    left: 45.1%;
    background: #fff;
  }
  .anniu-5 {
    position: absolute;
    bottom: 5.5%;
    left: 58.1%;
    background: #fff;
  }
  .anniu-7 {
    position: absolute;
    bottom: 5.5%;
    left: 71.1%;
    background-color: #ffffff;
  }

  .air-ba-jiance {
    height: 4.2rem;
  }
  // 屏幕小于960px
  img {
    //height: 100%;
  }
  .air_tab {
    padding: 50px 0;

    // 默认状态标签
    .tab-span-tit {
      width: 23%;
      font-size: 39px;
      border-radius: 100px;
      line-height: 1.1;
      padding: 15px 0;
    }
  }
  .jc-pic {
    width: 100%;
    // .jctupian{
    // 	// margin-left: 100rem !important;
    // margin-right: 0px !important;
    position: absolute;
    right: 15px;

    // }
    .jctupian img {
      // margin-left: -50% !important;
      width: 240px !important;
      height: 320px !important;
    }
  }
  .banner_pro3 {
    margin-top: 2%;
    // margin-right: 100%;
  }
  /deep/ .guolv-tit {
    width: 24% !important;
  }

  /deep/ .line {
    width: 600px !important;
  }

  .hepa_text {
    font-size: 12px !important;
  }
  .propk {
    z-index: 9;
    width: 100% !important;
    position: absolute;
    top: 44%;
    text-align: center;
  }
}

// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
  .propk {
    z-index: 9;
    width: 50px;
    position: absolute;
    top: 44%;
    text-align: center;
  }
  .propk video {
    width: 50% !important;
  }
  .swiper-button-prev-new {
    width: 44px;
    height: 44px;
    line-height: 44px !important;
    margin-top: -22px;
    background-size: 44px 44px;
  }

  .swiper-button-next-new {
    width: 44px;
    height: 44px;
    line-height: 44px !important;
    margin-top: -22px;
    background-size: 44px 44px;
  }

  .margin {
    flex: 1 1 0%;
    margin-left: 1.3%;
  }
  .rtxt-ma960 {
    display: none;
  }
  .rtxt-mi960 {
    display: block;
  }
  // 按钮位置
  .anniu-2 {
    position: absolute;
    top: 19.9%;
    left: 39%;
    background: #fff;
  }
  .anniu-4 {
    position: absolute;
    top: 19.9%;
    left: 52%;
    background: #fff;
  }
  .anniu-6 {
    position: absolute;
    top: 19.9%;
    left: 65%;
    background: #fff;
  }
  .anniu-1 {
    position: absolute;
    bottom: 5.5%;
    left: 32.6%;
    background: #fff;
  }
  .anniu-3 {
    position: absolute;
    bottom: 5.5%;
    left: 45.6%;
    background: #fff;
  }
  .anniu-5 {
    position: absolute;
    bottom: 5.5%;
    left: 58.6%;
    background: #fff;
  }
  .anniu-7 {
    position: absolute;
    bottom: 5.5%;
    left: 71.6%;
    background-color: #ffffff;
  }
  // 屏幕大于960px
  .air_tab {
    padding: 40px 0;

    // 默认状态标签
    .tab-span-tit {
      width: 15%;
      font-size: 19px;
      border-radius: 50px;
      padding: 10px 0;
    }
  }

  .close-btn {
    position: fixed;
    top: 40px;
    left: 40px;
    width: 120px;
    text-align: center;
    font-weight: 500;
    color: #fff;
    background-color: #ccc;
    color: #fff;
    border-radius: 10px;
    line-height: 2.5;
    cursor: pointer;
    z-index: 999;
  }
  .close-btn:hover {
    opacity: 0.8;
  }
}

.air_tab {
  background-color: #9f9fa0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  // 默认状态标签
  .tab-span-tit {
    border: 1px solid #fff;
    margin: 0 50px;
    color: #fff;
    cursor: pointer;
    font-weight: 400;
  }

  // 选中状态标签
  .select_tab {
    background-color: #fff;
    color: #6d6c6c;
  }
}

// ---------------------------- RA 488 ---------------------------------
@media only screen and (max-width: 960px) {
  .hepa_text {
    font-size: 12px !important;
  }
  // 屏幕小于960px
  // 标签栏
  .tabs_one /deep/ .el-tabs__nav {
    white-space: pre-wrap;
  }

  .tabs_one /deep/ .two-label {
    width: 50%;
  }

  .tabs_one .Air-two-mulu /deep/ .el-tabs__item {
    font-size: 48px !important;
    line-height: 2.5;
  }

  // 横线
  .banner_line1 {
    width: 800px;
  }

  .banner_line11 {
    width: 800px;
  }

  .banner_line2 {
    width: 550px;
  }

  .banner_line3 {
    width: 600px;
  }

  .banner_line5 {
    width: 700px;
    display: block;
  }

  .banner_line13 {
    width: 600px;
  }

  .tabs_one {
    // 文案
    .banner_copy1 {
      // margin-top: -6.145833rem !important;
      // margin-left: -3.833333rem !important;
      // 文字
      p {
        font-size: 58px;
      }
    }

    // 导航栏
    .Air-two-mulu {
      padding: 3% 0;

      // 按钮
      .two-anniu {
        width: 16%;

        .two-anniu-anniu {
          font-size: 44px;
          width: 75%;
        }
      }
    }

    .Air-two-mulu /deep/ .el-tabs__active-bar {
      height: 0;
    }

    // 有关产品//
    .Air-san-mlyi {
      .mlyi-list {
        // width: 100%;
        width: 100%;
        padding-left: 5%;
      }

      .mlyi-tit {
        font-size: 48px;
        width: 16%;
        margin: 0 auto;
        margin-bottom: 60px;
      }

      .yycp-title {
        font-size: 38px;
        margin-left: 25px;
      }
    }
    .Air-san-mlyi {
      .yycp-list {
        width: 95% !important;
        margin: auto !important;
        padding-left: 10% !important;
      }
      .yycp-second {
        width: 50% !important;
      }
    }

    // 七重过滤
    .Air-qi-guolv {
      // 标题
      .guolv-tit {
        font-size: 44px;
        width: 16%;
        margin: 0 auto;
        margin-bottom: 40px;
      }

      // 数字按钮
      .check_button {
        width: 60px;
        height: 60px;
        font-size: 40px;
        line-height: 1.5;
      }

      .guolv-desc {
        font-size: 48px;
      }

      // 第三标签
      .guolv-desc {
        .text_main {
          font-size: 46px;
          margin-bottom: 20px;
        }
      }
    }

    // 产品特点
    .Air-wu-protd {
      padding-bottom: 18%;

      .prottedian-tit {
        font-size: 48px;
        width: 16%;
        margin: 0 auto;
        margin-bottom: 50px;
      }
    }

    /* 服务介绍 */
    .Air-liu-jieshao {
      .fw-jieshao {
        font-size: 50px;
        width: 32%;
        margin: 0 auto;
        margin-bottom: 50px;
      }

      .jieshao-desc {
        width: 90%;
        font-size: 48px;
        line-height: 1.5;
      }

      .jieshao-list {
        width: 90%;

        .js-diyi {
          width: 50%;

          img {
            width: 83px;
          }

          .js-titbiaoti {
            font-size: 45px;
          }
        }
      }

      .js-diyi-zuihiu {
        width: 90%;
        padding: 20px 20px 20px 20px;

        img {
          width: 83px;
          height: 83px;
        }

        .js-titbiaoti-zuihiu {
          font-size: 45px;
          margin-top: 10px;
        }
      }

      .titbiaoti-zuihiu-ul {
        width: 100%;
        padding-left: 0;

        .zuihou-ul0li-tit {
          font-size: 45px;
          line-height: 1;
        }
      }
    }

    /* 规格 */
    .air-qi-guige {
      .guige-titbiaoti {
        font-size: 50px;
        width: 13%;
        margin: 0 auto;
        margin-bottom: 80px;
      }

      .guige-nr {
        width: 100%;
        border: none;
        box-sizing: border-box;
        padding-left: 5%;

        .guige-nr-left {
          width: 45%;
        }

        .guige-nr-rig {
          width: 50%;
        }

        .cp-mc-biaoti {
          font-size: 50px;
        }

        .cp-mc-shuoming {
          font-size: 45px;
        }
      }
    }

    /* 检测 */
    .air-ba-jiance {
      .jiance-titbiaoti {
        font-size: 50px;
        width: 13%;
        margin: 0 auto;
        margin-bottom: 80px;
      }

      .add_pic {
        display: none;
      }

      .jc-desc {
        font-size: 46px;
        line-height: 0.5;
      }

      .dialog {
        width: 100%;
      }

      .jctupian {
        width: 100%;
        // margin-left: -48%;
      }
      .jc-pic {
        width: 94%;
      }
    }

    /* 过滤配件 */
    .Air-jiu-guolvpj {
      .guolvpj-titbiaoti {
        font-size: 50px;
        width: 18%;
        margin: 0 auto;
        margin-bottom: 60px;
      }

      .guolvpj-nr {
        margin: 0 auto;
        margin-bottom: 70px;
      }

      .pj-anniu-zixun {
        width: 40%;
        font-size: 46px;
      }

      .pj-smaltit {
        font-size: 48px;
        line-height: 5px;
        margin-bottom: 30px;
      }

      .pj-line {
        width: 190px;
        border-bottom: 1px solid #0d1d41;
      }

      .cp-mc {
        .cp-mc-biaotigg {
          font-size: 42px;
          width: 40%;
        }

        .cp-mc-shuoming {
          font-size: 42px;
          width: 63%;
        }
      }
    }

    /* 其他 */
    .Air-shi-qita {
      .qita-titbiaoti {
        font-size: 50px;
      }
    }
  }
}

// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
  // 屏幕大于960px
  .tabs_one {
    // 文案
    .banner_copy1 {
      // 横线
      .banner_line1 {
        width: 600px;
      }

      .banner_line11 {
        width: 600px;
      }

      .banner_line2 {
        width: 450px;
      }

      .banner_line3 {
        width: 500px;
      }

      .banner_line5 {
        position: absolute;
        left: 0;
        margin-bottom: 0;
      }

      .banner_line13 {
        width: 500px;
      }
      /deep/ .line {
        width: 90% !important;
      }

      // 文字
      p {
        font-size: 48px;
        font-weight: lighter;
      }
    }

    // 导航栏
    .Air-two-mulu {
      padding: 2% 0;

      // 按钮
      .two-anniu {
        width: 14%;

        .two-anniu-anniu {
          font-size: 20px;
          width: 45%;
        }
      }
    }

    .Air-two-mulu /deep/ .el-tabs__active-bar {
      height: 4px;
    }

    // 有关产品
    .Air-san-mlyi {
      .mlyi-list {
        width: 80%;
      }

      .mlyi-tit {
        font-size: 30px;
        width: 7%;
        margin: 0 auto;
        margin-bottom: 20px;
      }

      .yycp-title {
        font-size: 30px;
        margin-left: 15px;
      }
    }

    // 七重过滤
    .Air-qi-guolv {
      // 标题
      .guolv-tit {
        font-size: 30px;
        width: 14%;
        margin: 0 auto;
        margin-bottom: 20px;
      }

      // 数字按钮
      .check_button {
        width: 40px;
        height: 40px;
        font-size: 24px;
        line-height: 40px;
      }

      .guolv-desc {
        font-size: 30px;

        .text_main {
          font-size: 26px;
        }
      }

      // 第三标签
      .guolv-desc {
        .text_main {
          font-size: 26px;
          margin-bottom: 10px;
        }
      }
    }

    // 产品特点
    .Air-wu-protd {
      padding-bottom: 8%;

      .prottedian-tit {
        font-size: 30px;
        width: 7%;
        margin: 0 auto;
      }
    }

    /* 服务介绍 */
    .Air-liu-jieshao {
      .fw-jieshao {
        font-size: 30px;
        width: 15%;
        margin: 0 auto;
      }

      .jieshao-desc {
        width: 72%;
        font-size: 25px;
        line-height: 2;
      }

      .jieshao-list {
        width: 70%;

        .js-diyi {
          width: 44%;

          img {
            width: 73px;
          }

          .js-titbiaoti {
            font-size: 25px;
          }
        }
      }

      .js-diyi-zuihiu {
        width: 64%;
        padding: 20px 20px 20px 40px;

        img {
          width: 73px;
          height: 73px;
        }

        .js-titbiaoti-zuihiu {
          font-size: 25px;
          margin-top: 20px;
        }
      }

      .titbiaoti-zuihiu-ul {
        width: 70%;

        .zuihou-ul0li-tit {
          font-size: 25px;
        }
      }
    }

    /* 规格 */
    .air-qi-guige {
      .guige-titbiaoti {
        font-size: 30px;
        width: 5%;
        margin: 0 auto;
      }

      .guige-nr {
        width: 75%;
        border-left: 1px solid #999b94;
        border-right: 1px solid #999b94;

        .guige-nr-left {
          width: 40%;
          padding: 0 20px;
        }

        .guige-nr-rig {
          width: 40%;
          padding: 0 40px;
        }

        .cp-mc-biaoti {
          font-size: 25px;
        }

        .cp-mc-shuoming {
          font-size: 25px;
        }
      }
    }

    /* 检测 */
    .air-ba-jiance {
      .jiance-titbiaoti {
        font-size: 30px;
        width: 6%;
        margin: 0 auto;
        margin-bottom: 30px;
      }

      .add_pic {
        display: block;
      }

      .jc-desc {
        font-size: 25px;
      }

      .jctupian {
        width: 30%;
        img {
          border: 0.006208rem solid black !important;
        }
      }

      .dialog {
        width: 100%;
      }

      .jc-pic {
        width: 60%;
        .jc-ju {
          margin-left: -3%;
          margin-right: 3%;
        }
      }
    }

    /* 过滤配件 */
    .Air-jiu-guolvpj {
      .guolvpj-titbiaoti {
        font-size: 30px;
        width: 7%;
        margin: 0 auto;
      }

      .pj-anniu-zixun {
        width: 26%;
        font-size: 26px;
      }

      .pj-smaltit {
        font-size: 25px;
        line-height: 45px;
      }

      .pj-line {
        width: 100px;
        border-bottom: 1px solid #0d1d41;
      }

      .guolvpj-nr {
        margin: 0 auto;
      }

      .cp-mc {
        .cp-mc-biaotigg {
          font-size: 25px;
          width: 25%;
        }

        .cp-mc-shuoming {
          font-size: 25px;
          width: 75%;
        }
      }
    }

    /* 其他 */
    .Air-shi-qita {
      .qita-titbiaoti {
        font-size: 30px;
      }
    }
  }

  .r800-c1 {
    left: 31% !important;
  }
  .r800-c2 {
    right: 37.7% !important;
  }
  .r800-c3 {
    top: 28% !important;
  }
}

.tabs_one {
  // 海报图
  .banner {
    width: 100%;
    background-color: #ffffff;
    // background: url(../assets/images/air-banner.png) no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;

    /*.banner_box{*/
    /*  width: 100%;*/
    /*  height: 901px;*/
    /*  position: relative;*/
    .banner_box {
      width: 100%;
      height: 900px;
      position: relative;

      .play_icon {
        width: 180px;
        position: absolute;
        top: 44%;
        left: 45%;
        cursor: pointer;
      }
    }

    // 内容
    .banner_main {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;

      // 产品图
      .banner_pro1 {
        width: 21%;
        height: auto;
        margin-right: 10%;
      }

      .banner_pro2222 {
        position: absolute;
        width: 100%;
        height: 4.692708rem;
        top: 0;
        right: 0;
        z-index: -100;
      }

      .banner_pro3333 {
        position: absolute;
        width: 100%;
        height: 4.692708rem;
        top: 0%;
        right: 0;
        z-index: -100;
      }

      .banner_pro2 {
        width: 545px;
        height: 740px;
        margin-left: 10%;
        bottom: -83px;
    position: relative;
      }

      .banner_pro3 {
        width: 690px;
        height: 646px;
        margin-right: 10%;
            position: relative;
    bottom: -142px;
      }

      .banner_pro4 {
        width: 620px;
        height: 740px;
        margin-right: 10%;
              bottom: -83px;
    position: relative;
      }

      // 文案
      .banner_copy1 {
        // 横线
        .banner_line1 {
          margin-bottom: 20px;
          padding-top: 70px;
        }

        .banner_line11 {
          margin-bottom: 20px;
          padding-top: 70px;
        }

        .banner_line2 {
          padding: 5% 0;
          height: auto;
        }

        .banner_line12 {
          padding: 5% 0;
        }

        // 文字
        p {
          color: #ffffff;
          letter-spacing: 6px;
          margin-bottom: 5%;
          margin-top: 15px;
          line-height: 1.5;
          text-align: left;
        }

        // logo
        .banner_logo {
          width: 295px;
        }
      }
    }
  }

  .ant-carousel /deep/ .slick-slide {
    text-align: center;
    height: 899px;
    line-height: 160px;
    overflow: hidden;
  }

  // .ant-carousel /deep/ .slick-slide img {
  //   width: 100%;
  // }
  .ant-carousel /deep/ .custom-slick-arrow {
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: #fff;
    border-radius: 25px;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.5;
  }

  .ant-carousel /deep/ .custom-slick-arrow:before {
    display: none;
  }

  .ant-carousel /deep/ .custom-slick-arrow:hover {
    opacity: 0.5;
  }

  .ant-carousel /deep/ .slick-slide h3 {
    color: #fff;
  }

  // 导航栏
  .Air-two-mulu {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    // 标签栏
    .two-label {
      display: flex;
      align-items: center;
      margin-right: 2%;
      color: #0d1d41;
    }

    // 按钮
    .two-anniu {
      display: flex;
      justify-content: space-around;

      .two-anniu-anniu {
        text-align: center;
        font-weight: 500;
        color: #fff;
        background-color: #e60012;
        border-radius: 10px;
        line-height: 2.5;
        cursor: pointer;
      }
    }
  }

  .Air-two-mulu /deep/ .el-tabs__nav-wrap::after {
    background-color: #fff;
  }

  .Air-two-mulu /deep/ .el-tabs__item.is-active {
    color: #0d1d41;
    margin-bottom: 10px;
  }

  .Air-two-mulu /deep/ .el-tabs__item:hover {
    color: #0d1d41;
  }

  .Air-two-mulu /deep/ .el-tabs__item {
    font-size: 30px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: #0d1d41;
  }

  .Air-two-mulu /deep/ .el-tabs__header {
    margin: 0;
  }

  // 有关产品
  .Air-san-mlyi {
    background-color: #b8e2f9;
    padding: 60px 0;

    .mlyi-tit {
      font-weight: 500;
      color: #0d1d41;
      text-align: center;
      border-bottom: 1px solid #fff;
      padding-bottom: 10px;
    }

    .mlyi-list {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;

      .yycp {
        width: 33%;
        display: flex;
        align-items: center;
        padding: 20px 0;

        .yycp-title {
          font-weight: 500;
          color: #0d1d41;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }

  // 七重过滤
  .Air-qi-guolv {
    background-color: #fff;
    padding: 30px 0;

    .num_box {
      position: relative;
    }

    // 数字按钮
    .check_button {
      border: 1px solid #595656;
      color: #595656;
      text-align: center;
      border-radius: 100px;
      cursor: pointer;
    }

    // .check_button:hover {
    //   background-color: #595656;
    //   color: #ffffff;
    // }

    .select_button {
      background-color: #595656 !important;
      color: #ffffff;
    }

    // 标题
    .guolv-tit {
      font-weight: 500;
      color: #0d1d41;
      text-align: center;
      border-bottom: 1px solid #858585;
      padding-bottom: 10px;
    }

    img {
      width: 75%;
    }

    .guolv-desc {
      border-top: 1px solid #858585;
      border-bottom: 1px solid #858585;
      width: 72%;
      margin: 0 auto;
      margin-top: 40px;
      padding: 20px 1.5% 1.5% 1.5%;

      .text_main {
        line-height: 1.5;
        letter-spacing: 2px;
        color: #0d1d41;

        span {
          font-weight: bold;
          font-size: 40px;
          line-height: 1;
        }
      }
    }
  }

  // 产品特点
  .Air-wu-protd {
    background-color: #d6d7d7;
    padding-top: 3%;

    .prottedian-tit {
      font-weight: 500;
      color: #30335c;
      text-align: center;
      border-bottom: 1px solid #fff;
      padding-bottom: 10px;
    }
  }

  /* 服务介绍 */
  .Air-liu-jieshao {
    background-color: #fff;
    padding: 90px;

    .fw-jieshao {
      font-weight: 500;
      color: #30335c;
      text-align: center;
      border-bottom: 1px solid #8d8c8d;
      padding-bottom: 10px;
    }

    .jieshao-desc {
      margin: 0 auto;
      color: #30335c;
      font-weight: 500;
      padding: 40px 0;
    }

    .jieshao-list {
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .js-diyi {
        display: flex;
        align-items: center;
        padding: 20px;

        .js-titbiaoti {
          color: #30335c;
          font-weight: 500;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 1;
          // -webkit-box-orient: vertical;
          margin-left: 10px;
        }
      }
    }

    .js-diyi-zuihiu {
      display: flex;
      margin: 0 auto;

      .js-titbiaoti-zuihiu {
        color: #30335c;
        font-weight: 500;
        margin-left: 10px;
      }
    }

    .titbiaoti-zuihiu-ul {
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .zuihou-ul0li-tit {
        width: 33%;
        padding: 20px 0;
        margin-right: 20px;

        span {
          font-weight: 500;
          color: #30335c;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  /* 规格 */
  .air-qi-guige {
    background-color: #f0f6dd;
    padding: 70px 0;

    .guige-titbiaoti {
      font-weight: 500;
      text-align: center;
      border-bottom: 1px solid #8d8c8d;
      padding-bottom: 10px;
      color: #30335c;
    }

    .guige-nr {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      margin-top: 3%;

      .cp-mc {
        display: flex;

        .cp-mc-biaoti {
          font-weight: bold;
          width: 45%;
          color: #30335c;
          line-height: 2;
        }

        .cp-mc-shuoming {
          font-weight: normal;
          align-items: flex-start;
          color: #30335c;
          line-height: 2;
        }
      }
    }
  }

  /* 检测 */
  .air-ba-jiance {
    background-color: #fff;
    padding: 70px 240px;

    .jiance-titbiaoti {
      font-family: 微软雅黑;
      font-weight: 500;
      text-align: center;
      color: #30335c;
      border-bottom: 1px solid #868586;
      padding-bottom: 10px;
    }

    .jc-desc {
      color: #30335c;
      font-weight: 500;
      margin: 0 auto;
      text-align: center;
      letter-spacing: 1px;
    }

    .add_pic {
      width: 54px;
      margin: 0 auto;
    }

    .jc-pic {
      width: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 30px 100px 0;
      text-align: center;

      .pn-arrow-pic {
        width: 50px;
        height: 150px;
        cursor: pointer;
        margin: 0 10px;
      }

      .jctupian {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        transition: all 0.6s;
        cursor: pointer;
        // margin-left: 20%;

        img {
          border: 1px solid black;
        }

        .pn-font {
          font-size: 20px;
          color: black;
          line-height: 1.2;
        }
      }
    }
  }

  /* 过滤配件 */
  .Air-jiu-guolvpj {
    background-color: #e3f3fc;
    padding: 70px 0;

    .guolvpj-titbiaoti {
      font-weight: 500;
      color: #112657;
      text-align: center;
      border-bottom: 1px solid #868586;
      padding-bottom: 10px;
    }

    .guolvpj-nr {
      width: 80%;
      display: flex;
      padding-top: 30px;

      .peijian-left {
        width: 50%;
        margin: 0 auto;

        .glpj-pic-bj {
          width: 80%;
        }

        .glpj-anniu {
          width: 80%;
          padding-top: 3%;
          text-align: center;

          .pj-anniu-zixun {
            font-weight: 500;
            color: #fff;
            background-color: #e60012;
            padding: 0 5%;
            cursor: pointer;
            border-radius: 8px;
            letter-spacing: 4px;
            line-height: 2.5;
            text-align: center;
            margin: 0 auto;
          }
        }
      }

      .peijian-rig {
        width: 60%;
        color: #112657;

        .pj-duanluo {
          padding: 20px 0;

          .pj-smaltit {
            font-weight: bold;
          }

          .cp-mc {
            display: flex;

            .cp-mc-biaotigg {
              font-weight: normal;
              letter-spacing: 2px;
            }

            .cp-mc-shuoming {
              font-weight: normal;
              align-items: flex-start;
            }
          }
        }
      }
    }
  }

  /* 其他 */
  .Air-shi-qita {
    background-color: #b7e2f8;
    padding: 3% 0 7% 0;

    .qita-titbiaoti {
      font-weight: 500;
      color: #0d1d41;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 3%;
    }
  }

  // ------------------------------- 表单 -------------------------------
  // ------------- mobile端样式 -------------
  @media only screen and (max-width: 960px) {
    img[lazy="loading"] {
      width: 30%;
      height: 30%;
      margin-left: 30%;
      margin-top: -2%;
    }

    .rtxt-ma960 {
      display: block;
    }
    .rtxt-mi960 {
      display: none;
    }
    // 屏幕小于960px
    .air_form {
      // 返回按钮
      .form_back {
        width: 200px;
        font-size: 44px;
        line-height: 80px;
        position: absolute;
        top: 5.5%;
        left: 10.5%;
      }

      // 标题
      .form_title {
        font-size: 50px;
      }
      // 标题
      .form_title {
        color: #0d1d41;
        letter-spacing: 2px;
        margin: 0 0 60px 0;
        text-align: center;
        padding-top: 1%;

        span {
          font-weight: bold;
        }
      }

      // 表单
      .form_main {
        .form_box {
          width: 80%;

          .form_input {
            font-size: 48px;
          }

          /deep/ .el-input__inner {
            font-size: 48px;
            height: 80px;
          }

          /deep/ .el-input__icon {
            line-height: 1.4;
          }

          /deep/ .el-select__caret {
            font-size: 50px !important;
          }
        }
      }

      // 提交按钮
      .form_button {
        margin: 0 auto;
        margin-top: 100px;

        // 文字
        .button_title {
          font-size: 48px;
          padding: 0 75px;
        }

        // 图标
        .button_icon {
          width: 85px;

          img {
            width: 75px;
            height: 75px;
          }
        }
      }
    }

    .banner-log-new-p {
      margin-top: 10px;
    }
  }

  // ------------- pc端样式 -------------
  @media only screen and (min-width: 960px) {
    .guolv-tit_muti1 {
      width: 180px !important;
    }
    img[lazy="loading"] {
      width: 30%;
      height: 30%;
      margin-left: 30%;
      margin-top: -2%;
    }

    // 屏幕大于960px
    .air_form {
      // 返回按钮
      .form_back {
        width: 100px;
        font-size: 24px;
        line-height: 50px;
        position: absolute;
        top: 6.5%;
        left: 22.5%;
      }

      // 标题
      .form_title {
        font-size: 35px;
      }
      // 标题
      .form_title {
        color: #0d1d41;
        letter-spacing: 2px;
        margin: 0 0 60px 0;
        text-align: center;

        span {
          font-weight: bold;
        }
      }

      // 表单
      .form_main {
        .form_box {
          width: 55%;

          .form_input {
            font-size: 20px;
          }

          /deep/ .el-input__inner {
            font-size: 20px;
          }
        }
      }

      // 提交按钮
      .form_button {
        margin: 0 auto;
        margin-top: 60px;

        // 文字
        .button_title {
          font-size: 22px;
          padding: 0 55px;
        }

        // 图标
        .button_icon {
          width: 55px;

          img {
            width: 45px;
            height: 45px;
          }
        }
      }
    }
  }

  .air_form {
    width: 100%;
    padding: 71px 0 0 0;
    position: relative;

    // 返回按钮
    .form_back {
      color: #ffffff;
      border-radius: 10px;
      background-color: #e60012;
      text-align: center;
      letter-spacing: 2px;
      cursor: pointer;
    }

    // // 标题
    // .form_title {
    //   color: #0d1d41;
    //   letter-spacing: 2px;
    //   margin: 0 0 60px 0;
    //   text-align: center;

    //   span {
    //     font-weight: bold;
    //   }
    // }

    // 表单
    .form_main {
      width: 100%;
      background-color: rgba(183, 226, 249, 0.6);
      padding: 90px 0 50px 0;

      .form_box {
        display: flex;
        align-items: center;
        margin: 0 auto;
        padding: 46px 0 43px 0;
        text-align: center;
        border-bottom: 2px solid #b6b8b6;

        .form_input {
          flex-grow: 1;
          background: none;
          border: none;
          color: #585858;
          outline: none;
        }

        /deep/ .el-input__inner {
          background-color: #d4eefb;
          border: none;
          color: #585858;
        }

        ::-webkit-input-placeholder {
          color: black;
        }

        ::-moz-input-input-placeholder {
          color: #585858;
        }
      }

      .form_box .img-wrap {
        width: 120px;
      }

      .form_box:nth-child(1) img {
        width: 30px;
        margin: 0 49px 0 41px;
      }

      .form_box:nth-child(2) img {
        width: 31px;
        margin: 0 48px 0 41px;
      }

      .form_box:nth-child(3) img {
        width: 33px;
        margin: 0 47px 0 40px;
      }

      .form_box:nth-child(4) img {
        width: 25px;
        margin: 0 51px 0 44px;
      }

      .form_box:nth-child(5) img {
        width: 40px;
        margin: 0 42px;
      }
    }

    // 提交按钮
    .form_button {
      margin-bottom: 60px;
      display: flex;
      justify-content: center;

      // 文字
      .button_title {
        color: #112653;
        font-family: "微软雅黑";
        border-radius: 100px 0 0 100px;
        background-color: #fff;
        display: flex;
        line-height: 2;
        align-items: center;
        letter-spacing: 5px;
        box-shadow: 0 2px 4px #cad0bb, 0 0 6px #cad0bb;
        cursor: pointer;
      }

      // 图标
      .button_icon {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0px 100px 100px 0px;
        box-shadow: 0 2px 4px #cad0bb, 0 0 6px #cad0bb;
        cursor: pointer;
        background-color: #112653;

        img {
          padding: 9px;
          border-radius: 0px 100px 100px 0px;
        }
      }
    }
  }
}

/deep/ .swiper-pagination-bullet {
  width: 0.15625rem !important;
  height: 0.010417rem !important;
  display: inline-block;
}

/deep/ .swiper-pagination-bullet {
  background: #fff;
}

/deep/ .swiper-pagination-bullet-active {
  background: #fff !important;
  opacity: 0.4;
}

/deep/ .swiper-button-next,
.swiper-button-prev {
  background-image: none !important;
  // height: 0.1875rem !important;
  // width: 0.1875rem !important;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  content: ">";
  color: white;
  text-align: center;
  opacity: 0.6;
}

/deep/ input ::--webkit-input-placeholder {
  color: #585858;
}

//其他浏览器
/deep/ ::-moz-placeholder {
  /* Firefox 19+ */
  color: #585858;
}

/deep/ :-ms-input-placeholder {
  /* IE 10+ */
  color: #585858;
}

/deep/ :-moz-placeholder {
  /* Firefox 18- */
  color: #585858;
}

/deep/ .protd-list-corlor {
  height: 1.5625rem;
}

// 遮罩
#mask {
  position: fixed;
  opacity: 0.75;
  //  filter:alpha(opacity=50);
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: black;
  z-index: 9;
  //  display: none;
}

#videl {
  width: 100%;
  z-index: 10;
}

@media screen and (max-height: 1050px) {
  video {
    width: 100%;
    // height: 600px;
  }

  .media1 {
    position: fixed;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .banner_line5 {
    width: 600px;
    position: absolute;
    left: 0;
    margin-bottom: 0;
    top: 42%;
  }
  #banner-ra800 {
    //  position: absolute; top: 15.3%; left: 0; align-items: center;
  }
}

@media screen and (max-height: 920px) {
  video {
    width: 100%;
  }

  .media1 {
    position: fixed;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .banner_line5 {
    width: 600px;
    position: absolute;
    left: 0;
    top: 42%;
  }
  #banner-ra800 {
    position: absolute;
    top: 0%;
    left: 0;
    align-items: center;
  }
}

/deep/ .swiper-pagination-bullets {
  bottom: 30px;
}

.hepa_text {
  font-size: 12px !important;
}
</style>

<style>
@media only screen and (max-width: 960px) {
  .hepa_text {
    font-size: 40px;
  }
}
</style>

<style>
@media only screen and (min-width: 960px) {
  .banner-log-new2 {
    margin-bottom: 50px;
  }
}
@media only screen and (max-width: 960px) {
  .banner-log-new2 {
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/air.vue